// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { client } from '../client.gen';
import { deleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentId, deleteApiExchangeByEncryptedOrderId, deleteApiOrdersByEncryptedOrderId, deleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationId, deleteApiOrdersByEncryptedOrderIdEventByEventId, deleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardId, deleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipId, deleteApiOrdersByEncryptedOrderIdProducts, deleteApiOrdersByEncryptedOrderIdTickets, deleteApiProfileMe, deleteApiTickets, getApiAppsettings, getApiAppsettingsAttributes, getApiAppsettingsPrivacyPolicy, getApiAppsettingsTermsAndConditions, getApiAuthExternalCallback, getApiAuthExternalProviders, getApiAuthExternalStart, getApiCheckoutByEncryptedOrderId, getApiCheckoutByEncryptedOrderIdOrderProtection, getApiCurrenciesRates, getApiDonations, getApiDonationsByDonationId, getApiDonationsGroups, getApiDonationsGroupsByUrl, getApiEventGroups, getApiEventGroupsByEventGroupId, getApiEventGroupsByEventGroupIdEventsCalendar, getApiEventGroupsByEventGroupIdEventsPaged, getApiEventGroupsByEventGroupIdSpecialOffers, getApiEventsByEventId, getApiEventsByEventIdProducts, getApiEventsByEventIdSeats, getApiEventsByEventIdUniqueCustomer, getApiEventsByEventIdUpcoming, getApiExchangeByEncryptedOrderIdCart, getApiExchangeByEncryptedOrderIdEventsByEventId, getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEvents, getApiForwardByTokenPdf, getApiGiftcardsGroups, getApiGiftcardsGroupsByGiftCardGroupId, getApiMemberships, getApiMembershipsByMembershipId, getApiMembershipsGroups, getApiMembershipsGroupsByUrl, getApiMobilepassGiftcardByEncryptedGiftcardId, getApiMobilepassMembershipByEncryptedMembershipInstanceId, getApiMobilepassOrderByEncryptedOrderId, getApiMobilepassSubscriptionByEncryptedTicketId, getApiMobilepassTicketByEncryptedTicketId, getApiOrdersByEncryptedOrderId, getApiOrdersByEncryptedOrderIdDeliveryTypes, getApiOrdersByEncryptedOrderIdDiscountClubs, getApiOrdersByEncryptedOrderIdEventsByEventIdAttendees, getApiProfileEventsByEventIdAttendees, getApiProfileGiftcards, getApiProfileMe, getApiProfileMeExport, getApiProfileMemberships, getApiProfileMePermissions, getApiProfileOrders, getApiReceiptByEncryptedOrderId, getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdf, getApiReceiptByEncryptedOrderIdRefundByEventId, getApiReceiptByEncryptedOrderIdStatus, getApiSpecialOffers, getApiSpecialOffersByEncryptedSpecialOfferId, getApiSubscriptionTypes, getApiSubscriptionTypesBySubscriptionTypeId, getApiSubscriptionTypesBySubscriptionTypeIdEventGroups, getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEvents, getApiVersion, type Options, patchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeId, patchApiCheckoutByEncryptedOrderIdPaymentSession, patchApiOrdersByEncryptedOrderIdEventsByEventIdAttendees, patchApiProfileEventsByEventIdAttendees, patchApiProfileMeDateOfBirth, patchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeId, postApiAuthChangePassword, postApiAuthConfirmRegistration, postApiAuthExternalDisconnect, postApiAuthExternalExchange, postApiAuthExternalLogin, postApiAuthForgotPassword, postApiAuthLogin, postApiAuthLogout, postApiAuthRefresh, postApiAuthResetPassword, postApiAuthSignup, postApiAuthWebuserExists, postApiCacheClearByTenantIdByKey, postApiCheckoutByEncryptedOrderIdConfirmPayment, postApiCheckoutByEncryptedOrderIdDetails, postApiCheckoutByEncryptedOrderIdGiftcard, postApiCheckoutByEncryptedOrderIdGiftcardValidate, postApiCheckoutByEncryptedOrderIdPaymentSession, postApiCheckoutByEncryptedOrderIdReserve, postApiEventsByEventIdSeatsAutoReserve, postApiEventsByEventIdSeatsMove, postApiEventsByEventIdSeatsReserve, postApiExchangeByEncryptedOrderIdEventsByEventIdConfirm, postApiExchangeByEncryptedOrderIdEventsByOldEventIdStart, postApiExchangeByEncryptedOrderIdFinalize, postApiExchangeByEncryptedOrderIdPaymentSession, postApiForward, postApiForwardLink, postApiGiftcardsPreviewPdf, postApiGiftcardsStatus, postApiInternalOrdersByOrderIdBriqpayRefund, postApiInternalOrdersByOrderIdCloseSale, postApiMobilepassOrderByEncryptedOrderIdAppleWalletLinks, postApiOrders, postApiOrdersByEncryptedOrderIdClaim, postApiOrdersByEncryptedOrderIdCustomerNote, postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApply, postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreview, postApiOrdersByEncryptedOrderIdDiscountCode, postApiOrdersByEncryptedOrderIdDonations, postApiOrdersByEncryptedOrderIdEvaluateRules, postApiOrdersByEncryptedOrderIdExpiryExtend, postApiOrdersByEncryptedOrderIdGiftcards, postApiOrdersByEncryptedOrderIdMemberships, postApiOrdersByEncryptedOrderIdProducts, postApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferId, postApiOrdersByEncryptedOrderIdSplit, postApiOrdersByEncryptedOrderIdTickets, postApiOrdersByEncryptedOrderIdTicketsUnnumbered, postApiProfileMe, postApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewal, postApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewal, postApiPurchaseByEncryptedOrderId, postApiReceiptByEncryptedOrderIdRefundByEventId, postApiTicketsValidate, postApiWaitingListByEventIdSignup, postApiWaitingListConfirm, putApiCheckoutByEncryptedOrderIdOrderProtection, putApiProfileMePermissionsByPermissionId } from '../sdk.gen';
import type { DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdData, DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdError, DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdResponse, DeleteApiExchangeByEncryptedOrderIdData, DeleteApiExchangeByEncryptedOrderIdError, DeleteApiOrdersByEncryptedOrderIdData, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdData, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdError, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdResponse, DeleteApiOrdersByEncryptedOrderIdError, DeleteApiOrdersByEncryptedOrderIdEventByEventIdData, DeleteApiOrdersByEncryptedOrderIdEventByEventIdError, DeleteApiOrdersByEncryptedOrderIdEventByEventIdResponse, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdData, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdError, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdResponse, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdData, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdError, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdResponse, DeleteApiOrdersByEncryptedOrderIdProductsData, DeleteApiOrdersByEncryptedOrderIdProductsError, DeleteApiOrdersByEncryptedOrderIdProductsResponse, DeleteApiOrdersByEncryptedOrderIdTicketsData, DeleteApiOrdersByEncryptedOrderIdTicketsError, DeleteApiOrdersByEncryptedOrderIdTicketsResponse, DeleteApiProfileMeData, DeleteApiProfileMeError, DeleteApiTicketsData, DeleteApiTicketsError, GetApiAppsettingsAttributesData, GetApiAppsettingsAttributesError, GetApiAppsettingsAttributesResponse, GetApiAppsettingsData, GetApiAppsettingsError, GetApiAppsettingsPrivacyPolicyData, GetApiAppsettingsPrivacyPolicyError, GetApiAppsettingsPrivacyPolicyResponse, GetApiAppsettingsResponse, GetApiAppsettingsTermsAndConditionsData, GetApiAppsettingsTermsAndConditionsError, GetApiAppsettingsTermsAndConditionsResponse, GetApiAuthExternalCallbackData, GetApiAuthExternalProvidersData, GetApiAuthExternalProvidersError, GetApiAuthExternalProvidersResponse, GetApiAuthExternalStartData, GetApiCheckoutByEncryptedOrderIdData, GetApiCheckoutByEncryptedOrderIdError, GetApiCheckoutByEncryptedOrderIdOrderProtectionData, GetApiCheckoutByEncryptedOrderIdOrderProtectionError, GetApiCheckoutByEncryptedOrderIdOrderProtectionResponse, GetApiCheckoutByEncryptedOrderIdResponse, GetApiCurrenciesRatesData, GetApiCurrenciesRatesError, GetApiCurrenciesRatesResponse, GetApiDonationsByDonationIdData, GetApiDonationsByDonationIdError, GetApiDonationsByDonationIdResponse, GetApiDonationsData, GetApiDonationsError, GetApiDonationsGroupsByUrlData, GetApiDonationsGroupsByUrlError, GetApiDonationsGroupsByUrlResponse, GetApiDonationsGroupsData, GetApiDonationsGroupsError, GetApiDonationsGroupsResponse, GetApiDonationsResponse, GetApiEventGroupsByEventGroupIdData, GetApiEventGroupsByEventGroupIdError, GetApiEventGroupsByEventGroupIdEventsCalendarData, GetApiEventGroupsByEventGroupIdEventsCalendarError, GetApiEventGroupsByEventGroupIdEventsCalendarResponse, GetApiEventGroupsByEventGroupIdEventsPagedData, GetApiEventGroupsByEventGroupIdEventsPagedError, GetApiEventGroupsByEventGroupIdEventsPagedResponse, GetApiEventGroupsByEventGroupIdResponse, GetApiEventGroupsByEventGroupIdSpecialOffersData, GetApiEventGroupsByEventGroupIdSpecialOffersError, GetApiEventGroupsByEventGroupIdSpecialOffersResponse, GetApiEventGroupsData, GetApiEventGroupsError, GetApiEventGroupsResponse, GetApiEventsByEventIdData, GetApiEventsByEventIdError, GetApiEventsByEventIdProductsData, GetApiEventsByEventIdProductsError, GetApiEventsByEventIdProductsResponse, GetApiEventsByEventIdResponse, GetApiEventsByEventIdSeatsData, GetApiEventsByEventIdSeatsError, GetApiEventsByEventIdSeatsResponse, GetApiEventsByEventIdUniqueCustomerData, GetApiEventsByEventIdUniqueCustomerError, GetApiEventsByEventIdUpcomingData, GetApiEventsByEventIdUpcomingError, GetApiEventsByEventIdUpcomingResponse, GetApiExchangeByEncryptedOrderIdCartData, GetApiExchangeByEncryptedOrderIdCartError, GetApiExchangeByEncryptedOrderIdCartResponse, GetApiExchangeByEncryptedOrderIdEventsByEventIdData, GetApiExchangeByEncryptedOrderIdEventsByEventIdError, GetApiExchangeByEncryptedOrderIdEventsByEventIdResponse, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsData, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsError, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsResponse, GetApiForwardByTokenPdfData, GetApiForwardByTokenPdfError, GetApiForwardByTokenPdfResponse, GetApiGiftcardsGroupsByGiftCardGroupIdData, GetApiGiftcardsGroupsByGiftCardGroupIdError, GetApiGiftcardsGroupsByGiftCardGroupIdResponse, GetApiGiftcardsGroupsData, GetApiGiftcardsGroupsError, GetApiGiftcardsGroupsResponse, GetApiMembershipsByMembershipIdData, GetApiMembershipsByMembershipIdError, GetApiMembershipsByMembershipIdResponse, GetApiMembershipsData, GetApiMembershipsError, GetApiMembershipsGroupsByUrlData, GetApiMembershipsGroupsByUrlError, GetApiMembershipsGroupsByUrlResponse, GetApiMembershipsGroupsData, GetApiMembershipsGroupsError, GetApiMembershipsGroupsResponse, GetApiMembershipsResponse, GetApiMobilepassGiftcardByEncryptedGiftcardIdData, GetApiMobilepassGiftcardByEncryptedGiftcardIdError, GetApiMobilepassGiftcardByEncryptedGiftcardIdResponse, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdData, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdError, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdResponse, GetApiMobilepassOrderByEncryptedOrderIdData, GetApiMobilepassOrderByEncryptedOrderIdError, GetApiMobilepassOrderByEncryptedOrderIdResponse, GetApiMobilepassSubscriptionByEncryptedTicketIdData, GetApiMobilepassSubscriptionByEncryptedTicketIdError, GetApiMobilepassSubscriptionByEncryptedTicketIdResponse, GetApiMobilepassTicketByEncryptedTicketIdData, GetApiMobilepassTicketByEncryptedTicketIdError, GetApiMobilepassTicketByEncryptedTicketIdResponse, GetApiOrdersByEncryptedOrderIdData, GetApiOrdersByEncryptedOrderIdDeliveryTypesData, GetApiOrdersByEncryptedOrderIdDeliveryTypesError, GetApiOrdersByEncryptedOrderIdDeliveryTypesResponse, GetApiOrdersByEncryptedOrderIdDiscountClubsData, GetApiOrdersByEncryptedOrderIdDiscountClubsError, GetApiOrdersByEncryptedOrderIdDiscountClubsResponse, GetApiOrdersByEncryptedOrderIdError, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesError, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponse, GetApiProfileEventsByEventIdAttendeesData, GetApiProfileEventsByEventIdAttendeesError, GetApiProfileEventsByEventIdAttendeesResponse, GetApiProfileGiftcardsData, GetApiProfileGiftcardsError, GetApiProfileGiftcardsResponse, GetApiProfileMeData, GetApiProfileMeError, GetApiProfileMeExportData, GetApiProfileMeExportError, GetApiProfileMeExportResponse, GetApiProfileMembershipsData, GetApiProfileMembershipsError, GetApiProfileMembershipsResponse, GetApiProfileMePermissionsData, GetApiProfileMePermissionsError, GetApiProfileMePermissionsResponse, GetApiProfileMeResponse, GetApiProfileOrdersData, GetApiProfileOrdersError, GetApiProfileOrdersResponse, GetApiReceiptByEncryptedOrderIdData, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfData, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfError, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfResponse, GetApiReceiptByEncryptedOrderIdError, GetApiReceiptByEncryptedOrderIdRefundByEventIdData, GetApiReceiptByEncryptedOrderIdRefundByEventIdError, GetApiReceiptByEncryptedOrderIdRefundByEventIdResponse, GetApiReceiptByEncryptedOrderIdResponse, GetApiReceiptByEncryptedOrderIdStatusData, GetApiReceiptByEncryptedOrderIdStatusError, GetApiReceiptByEncryptedOrderIdStatusResponse, GetApiSpecialOffersByEncryptedSpecialOfferIdData, GetApiSpecialOffersByEncryptedSpecialOfferIdError, GetApiSpecialOffersByEncryptedSpecialOfferIdResponse, GetApiSpecialOffersData, GetApiSpecialOffersError, GetApiSpecialOffersResponse, GetApiSubscriptionTypesBySubscriptionTypeIdData, GetApiSubscriptionTypesBySubscriptionTypeIdError, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsData, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsError, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsResponse, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsData, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsError, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsResponse, GetApiSubscriptionTypesBySubscriptionTypeIdResponse, GetApiSubscriptionTypesData, GetApiSubscriptionTypesError, GetApiSubscriptionTypesResponse, GetApiVersionData, GetApiVersionResponse, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdData, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdError, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdResponse, PatchApiCheckoutByEncryptedOrderIdPaymentSessionData, PatchApiCheckoutByEncryptedOrderIdPaymentSessionError, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesError, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponse, PatchApiProfileEventsByEventIdAttendeesData, PatchApiProfileEventsByEventIdAttendeesError, PatchApiProfileEventsByEventIdAttendeesResponse, PatchApiProfileMeDateOfBirthData, PatchApiProfileMeDateOfBirthError, PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdData, PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdError, PostApiAuthChangePasswordData, PostApiAuthChangePasswordError, PostApiAuthConfirmRegistrationData, PostApiAuthConfirmRegistrationError, PostApiAuthConfirmRegistrationResponse, PostApiAuthExternalDisconnectData, PostApiAuthExternalDisconnectError, PostApiAuthExternalExchangeData, PostApiAuthExternalExchangeError, PostApiAuthExternalExchangeResponse, PostApiAuthExternalLoginData, PostApiAuthExternalLoginError, PostApiAuthExternalLoginResponse, PostApiAuthForgotPasswordData, PostApiAuthForgotPasswordError, PostApiAuthForgotPasswordResponse, PostApiAuthLoginData, PostApiAuthLoginError, PostApiAuthLoginResponse, PostApiAuthLogoutData, PostApiAuthLogoutError, PostApiAuthRefreshData, PostApiAuthRefreshError, PostApiAuthRefreshResponse, PostApiAuthResetPasswordData, PostApiAuthResetPasswordError, PostApiAuthSignupData, PostApiAuthSignupError, PostApiAuthSignupResponse, PostApiAuthWebuserExistsData, PostApiAuthWebuserExistsError, PostApiAuthWebuserExistsResponse, PostApiCacheClearByTenantIdByKeyData, PostApiCacheClearByTenantIdByKeyError, PostApiCheckoutByEncryptedOrderIdConfirmPaymentData, PostApiCheckoutByEncryptedOrderIdConfirmPaymentError, PostApiCheckoutByEncryptedOrderIdConfirmPaymentResponse, PostApiCheckoutByEncryptedOrderIdDetailsData, PostApiCheckoutByEncryptedOrderIdDetailsError, PostApiCheckoutByEncryptedOrderIdDetailsResponse, PostApiCheckoutByEncryptedOrderIdGiftcardData, PostApiCheckoutByEncryptedOrderIdGiftcardError, PostApiCheckoutByEncryptedOrderIdGiftcardResponse, PostApiCheckoutByEncryptedOrderIdGiftcardValidateData, PostApiCheckoutByEncryptedOrderIdGiftcardValidateError, PostApiCheckoutByEncryptedOrderIdGiftcardValidateResponse, PostApiCheckoutByEncryptedOrderIdPaymentSessionData, PostApiCheckoutByEncryptedOrderIdPaymentSessionError, PostApiCheckoutByEncryptedOrderIdPaymentSessionResponse, PostApiCheckoutByEncryptedOrderIdReserveData, PostApiCheckoutByEncryptedOrderIdReserveError, PostApiCheckoutByEncryptedOrderIdReserveResponse, PostApiEventsByEventIdSeatsAutoReserveData, PostApiEventsByEventIdSeatsAutoReserveError, PostApiEventsByEventIdSeatsAutoReserveResponse, PostApiEventsByEventIdSeatsMoveData, PostApiEventsByEventIdSeatsMoveError, PostApiEventsByEventIdSeatsMoveResponse, PostApiEventsByEventIdSeatsReserveData, PostApiEventsByEventIdSeatsReserveError, PostApiEventsByEventIdSeatsReserveResponse, PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmData, PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmError, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartData, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartError, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartResponse, PostApiExchangeByEncryptedOrderIdFinalizeData, PostApiExchangeByEncryptedOrderIdFinalizeError, PostApiExchangeByEncryptedOrderIdFinalizeResponse, PostApiExchangeByEncryptedOrderIdPaymentSessionData, PostApiExchangeByEncryptedOrderIdPaymentSessionError, PostApiExchangeByEncryptedOrderIdPaymentSessionResponse, PostApiForwardData, PostApiForwardError, PostApiForwardLinkData, PostApiForwardLinkError, PostApiForwardLinkResponse, PostApiForwardResponse, PostApiGiftcardsPreviewPdfData, PostApiGiftcardsPreviewPdfError, PostApiGiftcardsPreviewPdfResponse, PostApiGiftcardsStatusData, PostApiGiftcardsStatusError, PostApiGiftcardsStatusResponse, PostApiInternalOrdersByOrderIdBriqpayRefundData, PostApiInternalOrdersByOrderIdBriqpayRefundError, PostApiInternalOrdersByOrderIdCloseSaleData, PostApiInternalOrdersByOrderIdCloseSaleError, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksData, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksError, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksResponse, PostApiOrdersByEncryptedOrderIdClaimData, PostApiOrdersByEncryptedOrderIdClaimError, PostApiOrdersByEncryptedOrderIdClaimResponse, PostApiOrdersByEncryptedOrderIdCustomerNoteData, PostApiOrdersByEncryptedOrderIdCustomerNoteError, PostApiOrdersByEncryptedOrderIdCustomerNoteResponse, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyData, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyError, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyResponse, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewData, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewError, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewResponse, PostApiOrdersByEncryptedOrderIdDiscountCodeData, PostApiOrdersByEncryptedOrderIdDiscountCodeError, PostApiOrdersByEncryptedOrderIdDiscountCodeResponse, PostApiOrdersByEncryptedOrderIdDonationsData, PostApiOrdersByEncryptedOrderIdDonationsError, PostApiOrdersByEncryptedOrderIdDonationsResponse, PostApiOrdersByEncryptedOrderIdEvaluateRulesData, PostApiOrdersByEncryptedOrderIdEvaluateRulesError, PostApiOrdersByEncryptedOrderIdEvaluateRulesResponse, PostApiOrdersByEncryptedOrderIdExpiryExtendData, PostApiOrdersByEncryptedOrderIdExpiryExtendError, PostApiOrdersByEncryptedOrderIdExpiryExtendResponse, PostApiOrdersByEncryptedOrderIdGiftcardsData, PostApiOrdersByEncryptedOrderIdGiftcardsError, PostApiOrdersByEncryptedOrderIdGiftcardsResponse, PostApiOrdersByEncryptedOrderIdMembershipsData, PostApiOrdersByEncryptedOrderIdMembershipsError, PostApiOrdersByEncryptedOrderIdMembershipsResponse, PostApiOrdersByEncryptedOrderIdProductsData, PostApiOrdersByEncryptedOrderIdProductsError, PostApiOrdersByEncryptedOrderIdProductsResponse, PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdData, PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdError, PostApiOrdersByEncryptedOrderIdSplitData, PostApiOrdersByEncryptedOrderIdSplitError, PostApiOrdersByEncryptedOrderIdSplitResponse, PostApiOrdersByEncryptedOrderIdTicketsData, PostApiOrdersByEncryptedOrderIdTicketsError, PostApiOrdersByEncryptedOrderIdTicketsResponse, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedData, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedError, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedResponse, PostApiOrdersData, PostApiOrdersError, PostApiOrdersResponse, PostApiProfileMeData, PostApiProfileMeError, PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalData, PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalError, PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalData, PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalError, PostApiProfileMeResponse, PostApiPurchaseByEncryptedOrderIdData, PostApiPurchaseByEncryptedOrderIdError, PostApiPurchaseByEncryptedOrderIdResponse, PostApiReceiptByEncryptedOrderIdRefundByEventIdData, PostApiReceiptByEncryptedOrderIdRefundByEventIdError, PostApiTicketsValidateData, PostApiTicketsValidateError, PostApiWaitingListByEventIdSignupData, PostApiWaitingListByEventIdSignupError, PostApiWaitingListConfirmData, PostApiWaitingListConfirmError, PutApiCheckoutByEncryptedOrderIdOrderProtectionData, PutApiCheckoutByEncryptedOrderIdOrderProtectionError, PutApiCheckoutByEncryptedOrderIdOrderProtectionResponse, PutApiProfileMePermissionsByPermissionIdData, PutApiProfileMePermissionsByPermissionIdError } from '../types.gen';
export type QueryKey<TOptions extends Options> = [Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
  _id: string;
  _infinite?: boolean;
  tags?: ReadonlyArray<string>;
}];
const createQueryKey = <TOptions extends Options,>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};
export const getApiAppsettingsQueryKey = (options?: Options<GetApiAppsettingsData>) => createQueryKey('getApiAppsettings', options);

/**
 * Retrieves Tenant and Skin specific appsettings.
 */
export const getApiAppsettingsOptions = (options?: Options<GetApiAppsettingsData>) => queryOptions<GetApiAppsettingsResponse, AxiosError<GetApiAppsettingsError>, GetApiAppsettingsResponse, ReturnType<typeof getApiAppsettingsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiAppsettings({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiAppsettingsQueryKey(options)
});
export const getApiAppsettingsAttributesQueryKey = (options?: Options<GetApiAppsettingsAttributesData>) => createQueryKey('getApiAppsettingsAttributes', options);

/**
 * Retrieves customer attribute settings.
 */
export const getApiAppsettingsAttributesOptions = (options?: Options<GetApiAppsettingsAttributesData>) => queryOptions<GetApiAppsettingsAttributesResponse, AxiosError<GetApiAppsettingsAttributesError>, GetApiAppsettingsAttributesResponse, ReturnType<typeof getApiAppsettingsAttributesQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiAppsettingsAttributes({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiAppsettingsAttributesQueryKey(options)
});
export const getApiAppsettingsTermsAndConditionsQueryKey = (options?: Options<GetApiAppsettingsTermsAndConditionsData>) => createQueryKey('getApiAppsettingsTermsAndConditions', options);

/**
 * Retrieves the skin's terms and conditions in the request culture.
 */
export const getApiAppsettingsTermsAndConditionsOptions = (options?: Options<GetApiAppsettingsTermsAndConditionsData>) => queryOptions<GetApiAppsettingsTermsAndConditionsResponse, AxiosError<GetApiAppsettingsTermsAndConditionsError>, GetApiAppsettingsTermsAndConditionsResponse, ReturnType<typeof getApiAppsettingsTermsAndConditionsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiAppsettingsTermsAndConditions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiAppsettingsTermsAndConditionsQueryKey(options)
});
export const getApiAppsettingsPrivacyPolicyQueryKey = (options?: Options<GetApiAppsettingsPrivacyPolicyData>) => createQueryKey('getApiAppsettingsPrivacyPolicy', options);

/**
 * Retrieves the skin's privacy policy in the request culture.
 */
export const getApiAppsettingsPrivacyPolicyOptions = (options?: Options<GetApiAppsettingsPrivacyPolicyData>) => queryOptions<GetApiAppsettingsPrivacyPolicyResponse, AxiosError<GetApiAppsettingsPrivacyPolicyError>, GetApiAppsettingsPrivacyPolicyResponse, ReturnType<typeof getApiAppsettingsPrivacyPolicyQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiAppsettingsPrivacyPolicy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiAppsettingsPrivacyPolicyQueryKey(options)
});

/**
 * Logs in a web user and retrieves a pair of tokens: access and refresh
 */
export const postApiAuthLoginMutation = (options?: Partial<Options<PostApiAuthLoginData>>): UseMutationOptions<PostApiAuthLoginResponse, AxiosError<PostApiAuthLoginError>, Options<PostApiAuthLoginData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthLoginResponse, AxiosError<PostApiAuthLoginError>, Options<PostApiAuthLoginData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthLogin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Registers a new web user and retrieves a pair of tokens: access and refresh
 */
export const postApiAuthSignupMutation = (options?: Partial<Options<PostApiAuthSignupData>>): UseMutationOptions<PostApiAuthSignupResponse, AxiosError<PostApiAuthSignupError>, Options<PostApiAuthSignupData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthSignupResponse, AxiosError<PostApiAuthSignupError>, Options<PostApiAuthSignupData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthSignup({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Checks whether a webuser already exists in the current skin matching any of the
 * supplied unique-on-webuser identifiers (Email, Mobile). Used by the signup gate
 * to branch to login when the identity is already taken.
 */
export const postApiAuthWebuserExistsMutation = (options?: Partial<Options<PostApiAuthWebuserExistsData>>): UseMutationOptions<PostApiAuthWebuserExistsResponse, AxiosError<PostApiAuthWebuserExistsError>, Options<PostApiAuthWebuserExistsData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthWebuserExistsResponse, AxiosError<PostApiAuthWebuserExistsError>, Options<PostApiAuthWebuserExistsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthWebuserExists({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Validates tokens and issues a new pair of tokens upon success
 */
export const postApiAuthRefreshMutation = (options?: Partial<Options<PostApiAuthRefreshData>>): UseMutationOptions<PostApiAuthRefreshResponse, AxiosError<PostApiAuthRefreshError>, Options<PostApiAuthRefreshData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthRefreshResponse, AxiosError<PostApiAuthRefreshError>, Options<PostApiAuthRefreshData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthRefresh({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Validates hashKey and resets user's password to a new one
 */
export const postApiAuthResetPasswordMutation = (options?: Partial<Options<PostApiAuthResetPasswordData>>): UseMutationOptions<unknown, AxiosError<PostApiAuthResetPasswordError>, Options<PostApiAuthResetPasswordData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiAuthResetPasswordError>, Options<PostApiAuthResetPasswordData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthResetPassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirms a freshly registered webuser via the signup email link
 */
export const postApiAuthConfirmRegistrationMutation = (options?: Partial<Options<PostApiAuthConfirmRegistrationData>>): UseMutationOptions<PostApiAuthConfirmRegistrationResponse, AxiosError<PostApiAuthConfirmRegistrationError>, Options<PostApiAuthConfirmRegistrationData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthConfirmRegistrationResponse, AxiosError<PostApiAuthConfirmRegistrationError>, Options<PostApiAuthConfirmRegistrationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthConfirmRegistration({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Updates the user's password to a new one
 */
export const postApiAuthChangePasswordMutation = (options?: Partial<Options<PostApiAuthChangePasswordData>>): UseMutationOptions<unknown, AxiosError<PostApiAuthChangePasswordError>, Options<PostApiAuthChangePasswordData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiAuthChangePasswordError>, Options<PostApiAuthChangePasswordData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthChangePassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Initiates a new procedure for resetting a user's password
 */
export const postApiAuthForgotPasswordMutation = (options?: Partial<Options<PostApiAuthForgotPasswordData>>): UseMutationOptions<PostApiAuthForgotPasswordResponse, AxiosError<PostApiAuthForgotPasswordError>, Options<PostApiAuthForgotPasswordData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthForgotPasswordResponse, AxiosError<PostApiAuthForgotPasswordError>, Options<PostApiAuthForgotPasswordData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthForgotPassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Allows authenticated user to logout
 */
export const postApiAuthLogoutMutation = (options?: Partial<Options<PostApiAuthLogoutData>>): UseMutationOptions<unknown, AxiosError<PostApiAuthLogoutError>, Options<PostApiAuthLogoutData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiAuthLogoutError>, Options<PostApiAuthLogoutData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthLogout({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Evicts the cached entries for tenantId. Requires the shared admin key configured
 * in `Cache:AdminClearKey`; returns 401 if the key is missing or doesn't match, 400 if the tenant
 * is not a configured tenant.
 */
export const postApiCacheClearByTenantIdByKeyMutation = (options?: Partial<Options<PostApiCacheClearByTenantIdByKeyData>>): UseMutationOptions<unknown, AxiosError<PostApiCacheClearByTenantIdByKeyError>, Options<PostApiCacheClearByTenantIdByKeyData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiCacheClearByTenantIdByKeyError>, Options<PostApiCacheClearByTenantIdByKeyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiCacheClearByTenantIdByKey({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiCheckoutByEncryptedOrderIdQueryKey = (options: Options<GetApiCheckoutByEncryptedOrderIdData>) => createQueryKey('getApiCheckoutByEncryptedOrderId', options);

/**
 * Fetches necessary information to proceed to checkout
 */
export const getApiCheckoutByEncryptedOrderIdOptions = (options: Options<GetApiCheckoutByEncryptedOrderIdData>) => queryOptions<GetApiCheckoutByEncryptedOrderIdResponse, AxiosError<GetApiCheckoutByEncryptedOrderIdError>, GetApiCheckoutByEncryptedOrderIdResponse, ReturnType<typeof getApiCheckoutByEncryptedOrderIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiCheckoutByEncryptedOrderId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiCheckoutByEncryptedOrderIdQueryKey(options)
});
export const getApiCheckoutByEncryptedOrderIdOrderProtectionQueryKey = (options: Options<GetApiCheckoutByEncryptedOrderIdOrderProtectionData>) => createQueryKey('getApiCheckoutByEncryptedOrderIdOrderProtection', options);

/**
 * Prices order protection for the order, or reports that it is not on offer.
 */
export const getApiCheckoutByEncryptedOrderIdOrderProtectionOptions = (options: Options<GetApiCheckoutByEncryptedOrderIdOrderProtectionData>) => queryOptions<GetApiCheckoutByEncryptedOrderIdOrderProtectionResponse, AxiosError<GetApiCheckoutByEncryptedOrderIdOrderProtectionError>, GetApiCheckoutByEncryptedOrderIdOrderProtectionResponse, ReturnType<typeof getApiCheckoutByEncryptedOrderIdOrderProtectionQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiCheckoutByEncryptedOrderIdOrderProtection({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiCheckoutByEncryptedOrderIdOrderProtectionQueryKey(options)
});

/**
 * Records the buyer's answer to order protection and puts the fee on the order, or takes it off.
 */
export const putApiCheckoutByEncryptedOrderIdOrderProtectionMutation = (options?: Partial<Options<PutApiCheckoutByEncryptedOrderIdOrderProtectionData>>): UseMutationOptions<PutApiCheckoutByEncryptedOrderIdOrderProtectionResponse, AxiosError<PutApiCheckoutByEncryptedOrderIdOrderProtectionError>, Options<PutApiCheckoutByEncryptedOrderIdOrderProtectionData>> => {
  const mutationOptions: UseMutationOptions<PutApiCheckoutByEncryptedOrderIdOrderProtectionResponse, AxiosError<PutApiCheckoutByEncryptedOrderIdOrderProtectionError>, Options<PutApiCheckoutByEncryptedOrderIdOrderProtectionData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await putApiCheckoutByEncryptedOrderIdOrderProtection({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Pre-validates a gift card against the current order: existence, balance, expiry, in-use, group-event coverage.
 * Soft-fail states (not found, in use, expired) surface as flags on the response; hard-fail order-compat issues return an error.
 */
export const postApiCheckoutByEncryptedOrderIdGiftcardValidateMutation = (options?: Partial<Options<PostApiCheckoutByEncryptedOrderIdGiftcardValidateData>>): UseMutationOptions<PostApiCheckoutByEncryptedOrderIdGiftcardValidateResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdGiftcardValidateError>, Options<PostApiCheckoutByEncryptedOrderIdGiftcardValidateData>> => {
  const mutationOptions: UseMutationOptions<PostApiCheckoutByEncryptedOrderIdGiftcardValidateResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdGiftcardValidateError>, Options<PostApiCheckoutByEncryptedOrderIdGiftcardValidateData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiCheckoutByEncryptedOrderIdGiftcardValidate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Registers a gift card to the current order
 */
export const postApiCheckoutByEncryptedOrderIdGiftcardMutation = (options?: Partial<Options<PostApiCheckoutByEncryptedOrderIdGiftcardData>>): UseMutationOptions<PostApiCheckoutByEncryptedOrderIdGiftcardResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdGiftcardError>, Options<PostApiCheckoutByEncryptedOrderIdGiftcardData>> => {
  const mutationOptions: UseMutationOptions<PostApiCheckoutByEncryptedOrderIdGiftcardResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdGiftcardError>, Options<PostApiCheckoutByEncryptedOrderIdGiftcardData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiCheckoutByEncryptedOrderIdGiftcard({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Remove a gift card from the current order
 */
export const deleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdMutation = (options?: Partial<Options<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdData>>): UseMutationOptions<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdResponse, AxiosError<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdError>, Options<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdResponse, AxiosError<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdError>, Options<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Updates delivery type for the current order
 */
export const patchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdMutation = (options?: Partial<Options<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdData>>): UseMutationOptions<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdResponse, AxiosError<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdError>, Options<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdData>> => {
  const mutationOptions: UseMutationOptions<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdResponse, AxiosError<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdError>, Options<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await patchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Restates the order's cart and buyer onto its open Briqpay session after the order changed at
 * checkout, so the open iframe charges what the order now owes. Call it between the iframe's
 * suspend and resume, never after the buyer pressed pay. On failure open a new session instead.
 */
export const patchApiCheckoutByEncryptedOrderIdPaymentSessionMutation = (options?: Partial<Options<PatchApiCheckoutByEncryptedOrderIdPaymentSessionData>>): UseMutationOptions<unknown, AxiosError<PatchApiCheckoutByEncryptedOrderIdPaymentSessionError>, Options<PatchApiCheckoutByEncryptedOrderIdPaymentSessionData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchApiCheckoutByEncryptedOrderIdPaymentSessionError>, Options<PatchApiCheckoutByEncryptedOrderIdPaymentSessionData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await patchApiCheckoutByEncryptedOrderIdPaymentSession({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Creates a Briqpay payment session for the order via tix.payment, returning the embeddable iframe snippet.
 */
export const postApiCheckoutByEncryptedOrderIdPaymentSessionMutation = (options?: Partial<Options<PostApiCheckoutByEncryptedOrderIdPaymentSessionData>>): UseMutationOptions<PostApiCheckoutByEncryptedOrderIdPaymentSessionResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdPaymentSessionError>, Options<PostApiCheckoutByEncryptedOrderIdPaymentSessionData>> => {
  const mutationOptions: UseMutationOptions<PostApiCheckoutByEncryptedOrderIdPaymentSessionResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdPaymentSessionError>, Options<PostApiCheckoutByEncryptedOrderIdPaymentSessionData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiCheckoutByEncryptedOrderIdPaymentSession({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirms the external payment once the customer returns from Briqpay: verifies the session
 * server-side and, when approved, closes the sale in-process so the receipt is ready without
 * waiting for the batched webhook. The browser's success flag is only the trigger — proof of
 * payment is the server-side session check.
 */
export const postApiCheckoutByEncryptedOrderIdConfirmPaymentMutation = (options?: Partial<Options<PostApiCheckoutByEncryptedOrderIdConfirmPaymentData>>): UseMutationOptions<PostApiCheckoutByEncryptedOrderIdConfirmPaymentResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdConfirmPaymentError>, Options<PostApiCheckoutByEncryptedOrderIdConfirmPaymentData>> => {
  const mutationOptions: UseMutationOptions<PostApiCheckoutByEncryptedOrderIdConfirmPaymentResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdConfirmPaymentError>, Options<PostApiCheckoutByEncryptedOrderIdConfirmPaymentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiCheckoutByEncryptedOrderIdConfirmPayment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reserves the order instead of paying for it. Requires a signed-in buyer and a workgroup that
 * offers online reservations. Extends the order's expiry per those settings.
 */
export const postApiCheckoutByEncryptedOrderIdReserveMutation = (options?: Partial<Options<PostApiCheckoutByEncryptedOrderIdReserveData>>): UseMutationOptions<PostApiCheckoutByEncryptedOrderIdReserveResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdReserveError>, Options<PostApiCheckoutByEncryptedOrderIdReserveData>> => {
  const mutationOptions: UseMutationOptions<PostApiCheckoutByEncryptedOrderIdReserveResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdReserveError>, Options<PostApiCheckoutByEncryptedOrderIdReserveData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiCheckoutByEncryptedOrderIdReserve({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Saves the customer's details before external payment: customer create/update, optional web user, links the customer
 * to the order, and bumps the order's expiry to give the customer time to complete payment.
 */
export const postApiCheckoutByEncryptedOrderIdDetailsMutation = (options?: Partial<Options<PostApiCheckoutByEncryptedOrderIdDetailsData>>): UseMutationOptions<PostApiCheckoutByEncryptedOrderIdDetailsResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdDetailsError>, Options<PostApiCheckoutByEncryptedOrderIdDetailsData>> => {
  const mutationOptions: UseMutationOptions<PostApiCheckoutByEncryptedOrderIdDetailsResponse, AxiosError<PostApiCheckoutByEncryptedOrderIdDetailsError>, Options<PostApiCheckoutByEncryptedOrderIdDetailsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiCheckoutByEncryptedOrderIdDetails({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiCurrenciesRatesQueryKey = (options?: Options<GetApiCurrenciesRatesData>) => createQueryKey('getApiCurrenciesRates', options);

/**
 * Retrieves available currency rates
 */
export const getApiCurrenciesRatesOptions = (options?: Options<GetApiCurrenciesRatesData>) => queryOptions<GetApiCurrenciesRatesResponse, AxiosError<GetApiCurrenciesRatesError>, GetApiCurrenciesRatesResponse, ReturnType<typeof getApiCurrenciesRatesQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiCurrenciesRates({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiCurrenciesRatesQueryKey(options)
});
export const getApiOrdersByEncryptedOrderIdDiscountClubsQueryKey = (options: Options<GetApiOrdersByEncryptedOrderIdDiscountClubsData>) => createQueryKey('getApiOrdersByEncryptedOrderIdDiscountClubs', options);

/**
 * The discount clubs offered for the order, each with the form the buyer fills in. A club with
 * no ticket left to discount is not listed.
 */
export const getApiOrdersByEncryptedOrderIdDiscountClubsOptions = (options: Options<GetApiOrdersByEncryptedOrderIdDiscountClubsData>) => queryOptions<GetApiOrdersByEncryptedOrderIdDiscountClubsResponse, AxiosError<GetApiOrdersByEncryptedOrderIdDiscountClubsError>, GetApiOrdersByEncryptedOrderIdDiscountClubsResponse, ReturnType<typeof getApiOrdersByEncryptedOrderIdDiscountClubsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiOrdersByEncryptedOrderIdDiscountClubs({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiOrdersByEncryptedOrderIdDiscountClubsQueryKey(options)
});

/**
 * Prices a card against the order's tickets without applying it.
 */
export const postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewError>, Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewError>, Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Applies a card: the discounted tickets move to the club's ticket type and price.
 */
export const postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyError>, Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyError>, Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApply({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiDonationsQueryKey = (options?: Options<GetApiDonationsData>) => createQueryKey('getApiDonations', options);

/**
 * Retrieves available donations for the Skin
 */
export const getApiDonationsOptions = (options?: Options<GetApiDonationsData>) => queryOptions<GetApiDonationsResponse, AxiosError<GetApiDonationsError>, GetApiDonationsResponse, ReturnType<typeof getApiDonationsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiDonations({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiDonationsQueryKey(options)
});
export const getApiDonationsByDonationIdQueryKey = (options: Options<GetApiDonationsByDonationIdData>) => createQueryKey('getApiDonationsByDonationId', options);

/**
 * Retrieves a donation by ID
 */
export const getApiDonationsByDonationIdOptions = (options: Options<GetApiDonationsByDonationIdData>) => queryOptions<GetApiDonationsByDonationIdResponse, AxiosError<GetApiDonationsByDonationIdError>, GetApiDonationsByDonationIdResponse, ReturnType<typeof getApiDonationsByDonationIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiDonationsByDonationId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiDonationsByDonationIdQueryKey(options)
});
export const getApiDonationsGroupsQueryKey = (options?: Options<GetApiDonationsGroupsData>) => createQueryKey('getApiDonationsGroups', options);

/**
 * Retrieves available Donation Groups for the Skin
 */
export const getApiDonationsGroupsOptions = (options?: Options<GetApiDonationsGroupsData>) => queryOptions<GetApiDonationsGroupsResponse, AxiosError<GetApiDonationsGroupsError>, GetApiDonationsGroupsResponse, ReturnType<typeof getApiDonationsGroupsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiDonationsGroups({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiDonationsGroupsQueryKey(options)
});
export const getApiDonationsGroupsByUrlQueryKey = (options: Options<GetApiDonationsGroupsByUrlData>) => createQueryKey('getApiDonationsGroupsByUrl', options);

/**
 * Retrieves Donation Group detail by URL slug
 */
export const getApiDonationsGroupsByUrlOptions = (options: Options<GetApiDonationsGroupsByUrlData>) => queryOptions<GetApiDonationsGroupsByUrlResponse, AxiosError<GetApiDonationsGroupsByUrlError>, GetApiDonationsGroupsByUrlResponse, ReturnType<typeof getApiDonationsGroupsByUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiDonationsGroupsByUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiDonationsGroupsByUrlQueryKey(options)
});
export const getApiEventsByEventIdQueryKey = (options: Options<GetApiEventsByEventIdData>) => createQueryKey('getApiEventsByEventId', options);

/**
 * Get Event by Id
 */
export const getApiEventsByEventIdOptions = (options: Options<GetApiEventsByEventIdData>) => queryOptions<GetApiEventsByEventIdResponse, AxiosError<GetApiEventsByEventIdError>, GetApiEventsByEventIdResponse, ReturnType<typeof getApiEventsByEventIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventsByEventId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventsByEventIdQueryKey(options)
});
export const getApiEventsByEventIdSeatsQueryKey = (options: Options<GetApiEventsByEventIdSeatsData>) => createQueryKey('getApiEventsByEventIdSeats', options);

/**
 *     Retrieves available seats by eventId, including those from special offers.
 * Pass includeSeats as false for the section map on its own, then
 * eventSectionIds to pull in a section's seats as the buyer opens it.
 * The map call describes the whole hall and carries the artwork; a call naming sections answers
 * for those sections alone, since seat availability is only read for them.
 */
export const getApiEventsByEventIdSeatsOptions = (options: Options<GetApiEventsByEventIdSeatsData>) => queryOptions<GetApiEventsByEventIdSeatsResponse, AxiosError<GetApiEventsByEventIdSeatsError>, GetApiEventsByEventIdSeatsResponse, ReturnType<typeof getApiEventsByEventIdSeatsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventsByEventIdSeats({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventsByEventIdSeatsQueryKey(options)
});

/**
 * Reserves seats
 */
export const postApiEventsByEventIdSeatsReserveMutation = (options?: Partial<Options<PostApiEventsByEventIdSeatsReserveData>>): UseMutationOptions<PostApiEventsByEventIdSeatsReserveResponse, AxiosError<PostApiEventsByEventIdSeatsReserveError>, Options<PostApiEventsByEventIdSeatsReserveData>> => {
  const mutationOptions: UseMutationOptions<PostApiEventsByEventIdSeatsReserveResponse, AxiosError<PostApiEventsByEventIdSeatsReserveError>, Options<PostApiEventsByEventIdSeatsReserveData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiEventsByEventIdSeatsReserve({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reserves seats by using filters
 */
export const postApiEventsByEventIdSeatsAutoReserveMutation = (options?: Partial<Options<PostApiEventsByEventIdSeatsAutoReserveData>>): UseMutationOptions<PostApiEventsByEventIdSeatsAutoReserveResponse, AxiosError<PostApiEventsByEventIdSeatsAutoReserveError>, Options<PostApiEventsByEventIdSeatsAutoReserveData>> => {
  const mutationOptions: UseMutationOptions<PostApiEventsByEventIdSeatsAutoReserveResponse, AxiosError<PostApiEventsByEventIdSeatsAutoReserveError>, Options<PostApiEventsByEventIdSeatsAutoReserveData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiEventsByEventIdSeatsAutoReserve({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Moves reserved seats to new seats around a target seat
 */
export const postApiEventsByEventIdSeatsMoveMutation = (options?: Partial<Options<PostApiEventsByEventIdSeatsMoveData>>): UseMutationOptions<PostApiEventsByEventIdSeatsMoveResponse, AxiosError<PostApiEventsByEventIdSeatsMoveError>, Options<PostApiEventsByEventIdSeatsMoveData>> => {
  const mutationOptions: UseMutationOptions<PostApiEventsByEventIdSeatsMoveResponse, AxiosError<PostApiEventsByEventIdSeatsMoveError>, Options<PostApiEventsByEventIdSeatsMoveData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiEventsByEventIdSeatsMove({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiEventsByEventIdUpcomingQueryKey = (options: Options<GetApiEventsByEventIdUpcomingData>) => createQueryKey('getApiEventsByEventIdUpcoming', options);

/**
 * Returns the upcoming-event landing page for the authenticated customer: the event, its
 * production description, venue, sibling showtimes, every order the customer holds and their
 * tickets for this event. Requires a logged-in customer.
 */
export const getApiEventsByEventIdUpcomingOptions = (options: Options<GetApiEventsByEventIdUpcomingData>) => queryOptions<GetApiEventsByEventIdUpcomingResponse, AxiosError<GetApiEventsByEventIdUpcomingError>, GetApiEventsByEventIdUpcomingResponse, ReturnType<typeof getApiEventsByEventIdUpcomingQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventsByEventIdUpcoming({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventsByEventIdUpcomingQueryKey(options)
});
export const getApiEventsByEventIdUniqueCustomerQueryKey = (options: Options<GetApiEventsByEventIdUniqueCustomerData>) => createQueryKey('getApiEventsByEventIdUniqueCustomer', options);

/**
 * Gets unique customer constraints for an event
 */
export const getApiEventsByEventIdUniqueCustomerOptions = (options: Options<GetApiEventsByEventIdUniqueCustomerData>) => queryOptions<unknown, AxiosError<GetApiEventsByEventIdUniqueCustomerError>, unknown, ReturnType<typeof getApiEventsByEventIdUniqueCustomerQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventsByEventIdUniqueCustomer({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventsByEventIdUniqueCustomerQueryKey(options)
});
export const getApiEventGroupsQueryKey = (options?: Options<GetApiEventGroupsData>) => createQueryKey('getApiEventGroups', options);

/**
 * Retrieves all available event groups
 */
export const getApiEventGroupsOptions = (options?: Options<GetApiEventGroupsData>) => queryOptions<GetApiEventGroupsResponse, AxiosError<GetApiEventGroupsError>, GetApiEventGroupsResponse, ReturnType<typeof getApiEventGroupsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventGroups({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventGroupsQueryKey(options)
});
export const getApiEventGroupsByEventGroupIdQueryKey = (options: Options<GetApiEventGroupsByEventGroupIdData>) => createQueryKey('getApiEventGroupsByEventGroupId', options);

/**
 * Retrieves available group events by eventGroupId
 */
export const getApiEventGroupsByEventGroupIdOptions = (options: Options<GetApiEventGroupsByEventGroupIdData>) => queryOptions<GetApiEventGroupsByEventGroupIdResponse, AxiosError<GetApiEventGroupsByEventGroupIdError>, GetApiEventGroupsByEventGroupIdResponse, ReturnType<typeof getApiEventGroupsByEventGroupIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventGroupsByEventGroupId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventGroupsByEventGroupIdQueryKey(options)
});
export const getApiEventGroupsByEventGroupIdEventsPagedQueryKey = (options: Options<GetApiEventGroupsByEventGroupIdEventsPagedData>) => createQueryKey('getApiEventGroupsByEventGroupIdEventsPaged', options);

/**
 * Retrieves available paged events by eventGroupId and as optional special offers
 */
export const getApiEventGroupsByEventGroupIdEventsPagedOptions = (options: Options<GetApiEventGroupsByEventGroupIdEventsPagedData>) => queryOptions<GetApiEventGroupsByEventGroupIdEventsPagedResponse, AxiosError<GetApiEventGroupsByEventGroupIdEventsPagedError>, GetApiEventGroupsByEventGroupIdEventsPagedResponse, ReturnType<typeof getApiEventGroupsByEventGroupIdEventsPagedQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventGroupsByEventGroupIdEventsPaged({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventGroupsByEventGroupIdEventsPagedQueryKey(options)
});
export const getApiEventGroupsByEventGroupIdEventsCalendarQueryKey = (options: Options<GetApiEventGroupsByEventGroupIdEventsCalendarData>) => createQueryKey('getApiEventGroupsByEventGroupIdEventsCalendar', options);

/**
 * Retrieves available events for calendar view by eventGroupId and as optional special offers
 */
export const getApiEventGroupsByEventGroupIdEventsCalendarOptions = (options: Options<GetApiEventGroupsByEventGroupIdEventsCalendarData>) => queryOptions<GetApiEventGroupsByEventGroupIdEventsCalendarResponse, AxiosError<GetApiEventGroupsByEventGroupIdEventsCalendarError>, GetApiEventGroupsByEventGroupIdEventsCalendarResponse, ReturnType<typeof getApiEventGroupsByEventGroupIdEventsCalendarQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventGroupsByEventGroupIdEventsCalendar({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventGroupsByEventGroupIdEventsCalendarQueryKey(options)
});
export const getApiEventGroupsByEventGroupIdSpecialOffersQueryKey = (options: Options<GetApiEventGroupsByEventGroupIdSpecialOffersData>) => createQueryKey('getApiEventGroupsByEventGroupIdSpecialOffers', options);

/**
 * Returns all special offers tied to the event group specified by eventGroupId
 */
export const getApiEventGroupsByEventGroupIdSpecialOffersOptions = (options: Options<GetApiEventGroupsByEventGroupIdSpecialOffersData>) => queryOptions<GetApiEventGroupsByEventGroupIdSpecialOffersResponse, AxiosError<GetApiEventGroupsByEventGroupIdSpecialOffersError>, GetApiEventGroupsByEventGroupIdSpecialOffersResponse, ReturnType<typeof getApiEventGroupsByEventGroupIdSpecialOffersQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventGroupsByEventGroupIdSpecialOffers({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventGroupsByEventGroupIdSpecialOffersQueryKey(options)
});
export const getApiExchangeByEncryptedOrderIdEventsByEventIdQueryKey = (options: Options<GetApiExchangeByEncryptedOrderIdEventsByEventIdData>) => createQueryKey('getApiExchangeByEncryptedOrderIdEventsByEventId', options);

/**
 * Returns exchange eligibility rules and the list of candidate event groups for an order/event.
 * Use subscriptionTypeId to scope to a specific subscription group; omit it
 * (or pass null) to target non-subscription tickets when an order has both kinds for the event.
 */
export const getApiExchangeByEncryptedOrderIdEventsByEventIdOptions = (options: Options<GetApiExchangeByEncryptedOrderIdEventsByEventIdData>) => queryOptions<GetApiExchangeByEncryptedOrderIdEventsByEventIdResponse, AxiosError<GetApiExchangeByEncryptedOrderIdEventsByEventIdError>, GetApiExchangeByEncryptedOrderIdEventsByEventIdResponse, ReturnType<typeof getApiExchangeByEncryptedOrderIdEventsByEventIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiExchangeByEncryptedOrderIdEventsByEventId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiExchangeByEncryptedOrderIdEventsByEventIdQueryKey(options)
});
export const getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsQueryKey = (options: Options<GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsData>) => createQueryKey('getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEvents', options);

/**
 * Returns the events within a candidate event group that are actually eligible for exchange for the
 * given order/event. The generic events endpoint is not exchange-aware and would list dates that
 * fail downstream, so the frontend uses this to populate the date picker. Pass
 * subscriptionTypeId to scope to a subscription group; omit it for non-subscription tickets.
 */
export const getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsOptions = (options: Options<GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsData>) => queryOptions<GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsResponse, AxiosError<GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsError>, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsResponse, ReturnType<typeof getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEvents({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsQueryKey(options)
});

/**
 * Starts an in-flight exchange: creates a Reserved exchange (staging) order from the already-reserved
 * new tickets and returns its encrypted id for the frontend to drive cart/checkout against.
 */
export const postApiExchangeByEncryptedOrderIdEventsByOldEventIdStartMutation = (options?: Partial<Options<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartData>>): UseMutationOptions<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartResponse, AxiosError<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartError>, Options<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartData>> => {
  const mutationOptions: UseMutationOptions<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartResponse, AxiosError<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartError>, Options<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiExchangeByEncryptedOrderIdEventsByOldEventIdStart({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Drops an exchange in progress, releasing the seats its staging order holds. The original order and
 * its tickets are left exactly as they were. Succeeds when there is nothing in flight, so calling it
 * twice is harmless; returns 409 once the exchange has been applied or while a payment is closing.
 */
export const deleteApiExchangeByEncryptedOrderIdMutation = (options?: Partial<Options<DeleteApiExchangeByEncryptedOrderIdData>>): UseMutationOptions<unknown, AxiosError<DeleteApiExchangeByEncryptedOrderIdError>, Options<DeleteApiExchangeByEncryptedOrderIdData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteApiExchangeByEncryptedOrderIdError>, Options<DeleteApiExchangeByEncryptedOrderIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiExchangeByEncryptedOrderId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiExchangeByEncryptedOrderIdCartQueryKey = (options: Options<GetApiExchangeByEncryptedOrderIdCartData>) => createQueryKey('getApiExchangeByEncryptedOrderIdCart', options);

/**
 * Returns the exchange (staging) order as a normal cart plus the exchange overlay:
 * returned tickets, change fee, and net amount to settle.
 */
export const getApiExchangeByEncryptedOrderIdCartOptions = (options: Options<GetApiExchangeByEncryptedOrderIdCartData>) => queryOptions<GetApiExchangeByEncryptedOrderIdCartResponse, AxiosError<GetApiExchangeByEncryptedOrderIdCartError>, GetApiExchangeByEncryptedOrderIdCartResponse, ReturnType<typeof getApiExchangeByEncryptedOrderIdCartQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiExchangeByEncryptedOrderIdCart({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiExchangeByEncryptedOrderIdCartQueryKey(options)
});

/**
 * Creates a Briqpay payment session for the exchange's net amount (change fee + upgrade, less any
 * returned-ticket credit). Returns 409 when no payment is required (net zero).
 */
export const postApiExchangeByEncryptedOrderIdPaymentSessionMutation = (options?: Partial<Options<PostApiExchangeByEncryptedOrderIdPaymentSessionData>>): UseMutationOptions<PostApiExchangeByEncryptedOrderIdPaymentSessionResponse, AxiosError<PostApiExchangeByEncryptedOrderIdPaymentSessionError>, Options<PostApiExchangeByEncryptedOrderIdPaymentSessionData>> => {
  const mutationOptions: UseMutationOptions<PostApiExchangeByEncryptedOrderIdPaymentSessionResponse, AxiosError<PostApiExchangeByEncryptedOrderIdPaymentSessionError>, Options<PostApiExchangeByEncryptedOrderIdPaymentSessionData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiExchangeByEncryptedOrderIdPaymentSession({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Finalizes an exchange that needs no payment (equal swap, free change, or a cheaper swap whose
 * excess is refunded as gift card / donation). The frontend calls this after
 * `payment-session` returns `NoPaymentRequired`. Returns the original order id for the receipt.
 */
export const postApiExchangeByEncryptedOrderIdFinalizeMutation = (options?: Partial<Options<PostApiExchangeByEncryptedOrderIdFinalizeData>>): UseMutationOptions<PostApiExchangeByEncryptedOrderIdFinalizeResponse, AxiosError<PostApiExchangeByEncryptedOrderIdFinalizeError>, Options<PostApiExchangeByEncryptedOrderIdFinalizeData>> => {
  const mutationOptions: UseMutationOptions<PostApiExchangeByEncryptedOrderIdFinalizeResponse, AxiosError<PostApiExchangeByEncryptedOrderIdFinalizeError>, Options<PostApiExchangeByEncryptedOrderIdFinalizeData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiExchangeByEncryptedOrderIdFinalize({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirms an exchange — swaps old tickets for new reserved tickets and writes audit entries
 */
export const postApiExchangeByEncryptedOrderIdEventsByEventIdConfirmMutation = (options?: Partial<Options<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmData>>): UseMutationOptions<unknown, AxiosError<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmError>, Options<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmError>, Options<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiExchangeByEncryptedOrderIdEventsByEventIdConfirm({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiAuthExternalProvidersQueryKey = (options?: Options<GetApiAuthExternalProvidersData>) => createQueryKey('getApiAuthExternalProviders', options);

/**
 * Returns a list of available external providers
 */
export const getApiAuthExternalProvidersOptions = (options?: Options<GetApiAuthExternalProvidersData>) => queryOptions<GetApiAuthExternalProvidersResponse, AxiosError<GetApiAuthExternalProvidersError>, GetApiAuthExternalProvidersResponse, ReturnType<typeof getApiAuthExternalProvidersQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiAuthExternalProviders({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiAuthExternalProvidersQueryKey(options)
});

/**
 * Logs in (or signs up) a web user using an external provider
 */
export const postApiAuthExternalLoginMutation = (options?: Partial<Options<PostApiAuthExternalLoginData>>): UseMutationOptions<PostApiAuthExternalLoginResponse, AxiosError<PostApiAuthExternalLoginError>, Options<PostApiAuthExternalLoginData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthExternalLoginResponse, AxiosError<PostApiAuthExternalLoginError>, Options<PostApiAuthExternalLoginData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthExternalLogin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Disconnect a web user from an external provider
 */
export const postApiAuthExternalDisconnectMutation = (options?: Partial<Options<PostApiAuthExternalDisconnectData>>): UseMutationOptions<unknown, AxiosError<PostApiAuthExternalDisconnectError>, Options<PostApiAuthExternalDisconnectData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiAuthExternalDisconnectError>, Options<PostApiAuthExternalDisconnectData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthExternalDisconnect({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiAuthExternalStartQueryKey = (options?: Options<GetApiAuthExternalStartData>) => createQueryKey('getApiAuthExternalStart', options);

/**
 * Begins the flow by redirecting the browser to the provider's authorize URL.
 */
export const getApiAuthExternalStartOptions = (options?: Options<GetApiAuthExternalStartData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getApiAuthExternalStartQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiAuthExternalStart({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiAuthExternalStartQueryKey(options)
});
export const getApiAuthExternalCallbackQueryKey = (options?: Options<GetApiAuthExternalCallbackData>) => createQueryKey('getApiAuthExternalCallback', options);

/**
 * Provider callback. Redirects back to the tenant's return URL with a one-time code appended.
 * OAuth 2.0 providers return `code`; Twitter (OAuth 1.0a) returns
 * `oauth_token`/`oauth_verifier`.
 */
export const getApiAuthExternalCallbackOptions = (options?: Options<GetApiAuthExternalCallbackData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getApiAuthExternalCallbackQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiAuthExternalCallback({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiAuthExternalCallbackQueryKey(options)
});

/**
 * Redeems the exchange token for a JWT token pair. The token and the PKCE code verifier travel in
 * the body (never a URL), so a token captured from a URL or log can't be redeemed without the verifier.
 */
export const postApiAuthExternalExchangeMutation = (options?: Partial<Options<PostApiAuthExternalExchangeData>>): UseMutationOptions<PostApiAuthExternalExchangeResponse, AxiosError<PostApiAuthExternalExchangeError>, Options<PostApiAuthExternalExchangeData>> => {
  const mutationOptions: UseMutationOptions<PostApiAuthExternalExchangeResponse, AxiosError<PostApiAuthExternalExchangeError>, Options<PostApiAuthExternalExchangeData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiAuthExternalExchange({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Forwards the selected tickets to a recipient email and returns the forward token (for "copy link").
 */
export const postApiForwardMutation = (options?: Partial<Options<PostApiForwardData>>): UseMutationOptions<PostApiForwardResponse, AxiosError<PostApiForwardError>, Options<PostApiForwardData>> => {
  const mutationOptions: UseMutationOptions<PostApiForwardResponse, AxiosError<PostApiForwardError>, Options<PostApiForwardData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiForward({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Builds the shareable download token for the selected tickets without sending an email.
 */
export const postApiForwardLinkMutation = (options?: Partial<Options<PostApiForwardLinkData>>): UseMutationOptions<PostApiForwardLinkResponse, AxiosError<PostApiForwardLinkError>, Options<PostApiForwardLinkData>> => {
  const mutationOptions: UseMutationOptions<PostApiForwardLinkResponse, AxiosError<PostApiForwardLinkError>, Options<PostApiForwardLinkData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiForwardLink({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiForwardByTokenPdfQueryKey = (options: Options<GetApiForwardByTokenPdfData>) => createQueryKey('getApiForwardByTokenPdf', options);

/**
 * Streams the PDF for the tickets encoded in a forward token, for an account-less recipient
 * following a forwarded link. The token is the only credential.
 */
export const getApiForwardByTokenPdfOptions = (options: Options<GetApiForwardByTokenPdfData>) => queryOptions<GetApiForwardByTokenPdfResponse, AxiosError<GetApiForwardByTokenPdfError>, GetApiForwardByTokenPdfResponse, ReturnType<typeof getApiForwardByTokenPdfQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiForwardByTokenPdf({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiForwardByTokenPdfQueryKey(options)
});

/**
 * Retrieves GiftCard status by number and pin
 */
export const postApiGiftcardsStatusMutation = (options?: Partial<Options<PostApiGiftcardsStatusData>>): UseMutationOptions<PostApiGiftcardsStatusResponse, AxiosError<PostApiGiftcardsStatusError>, Options<PostApiGiftcardsStatusData>> => {
  const mutationOptions: UseMutationOptions<PostApiGiftcardsStatusResponse, AxiosError<PostApiGiftcardsStatusError>, Options<PostApiGiftcardsStatusData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiGiftcardsStatus({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiGiftcardsGroupsQueryKey = (options?: Options<GetApiGiftcardsGroupsData>) => createQueryKey('getApiGiftcardsGroups', options);

/**
 * Retrieves available GiftCards Groups for the Skin
 */
export const getApiGiftcardsGroupsOptions = (options?: Options<GetApiGiftcardsGroupsData>) => queryOptions<GetApiGiftcardsGroupsResponse, AxiosError<GetApiGiftcardsGroupsError>, GetApiGiftcardsGroupsResponse, ReturnType<typeof getApiGiftcardsGroupsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiGiftcardsGroups({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiGiftcardsGroupsQueryKey(options)
});
export const getApiGiftcardsGroupsByGiftCardGroupIdQueryKey = (options: Options<GetApiGiftcardsGroupsByGiftCardGroupIdData>) => createQueryKey('getApiGiftcardsGroupsByGiftCardGroupId', options);

/**
 * Retrieves GiftCard Group By GiftCardGroupId if available
 */
export const getApiGiftcardsGroupsByGiftCardGroupIdOptions = (options: Options<GetApiGiftcardsGroupsByGiftCardGroupIdData>) => queryOptions<GetApiGiftcardsGroupsByGiftCardGroupIdResponse, AxiosError<GetApiGiftcardsGroupsByGiftCardGroupIdError>, GetApiGiftcardsGroupsByGiftCardGroupIdResponse, ReturnType<typeof getApiGiftcardsGroupsByGiftCardGroupIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiGiftcardsGroupsByGiftCardGroupId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiGiftcardsGroupsByGiftCardGroupIdQueryKey(options)
});

/**
 * Streams a pre-purchase gift-card preview PDF, rendered by the PDF service, for the buyer's chosen
 * layout, amount and message.
 */
export const postApiGiftcardsPreviewPdfMutation = (options?: Partial<Options<PostApiGiftcardsPreviewPdfData>>): UseMutationOptions<PostApiGiftcardsPreviewPdfResponse, AxiosError<PostApiGiftcardsPreviewPdfError>, Options<PostApiGiftcardsPreviewPdfData>> => {
  const mutationOptions: UseMutationOptions<PostApiGiftcardsPreviewPdfResponse, AxiosError<PostApiGiftcardsPreviewPdfError>, Options<PostApiGiftcardsPreviewPdfData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiGiftcardsPreviewPdf({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Applies Briqpay's final refund_status. Idempotent: a finished refund returns 200.
 */
export const postApiInternalOrdersByOrderIdBriqpayRefundMutation = (options?: Partial<Options<PostApiInternalOrdersByOrderIdBriqpayRefundData>>): UseMutationOptions<unknown, AxiosError<PostApiInternalOrdersByOrderIdBriqpayRefundError>, Options<PostApiInternalOrdersByOrderIdBriqpayRefundData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiInternalOrdersByOrderIdBriqpayRefundError>, Options<PostApiInternalOrdersByOrderIdBriqpayRefundData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiInternalOrdersByOrderIdBriqpayRefund({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Closes the sale for an order whose payment was approved by an external PSP.
 * Idempotent: repeat calls after a completed close return 200.
 */
export const postApiInternalOrdersByOrderIdCloseSaleMutation = (options?: Partial<Options<PostApiInternalOrdersByOrderIdCloseSaleData>>): UseMutationOptions<unknown, AxiosError<PostApiInternalOrdersByOrderIdCloseSaleError>, Options<PostApiInternalOrdersByOrderIdCloseSaleData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiInternalOrdersByOrderIdCloseSaleError>, Options<PostApiInternalOrdersByOrderIdCloseSaleData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiInternalOrdersByOrderIdCloseSale({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiMembershipsQueryKey = (options?: Options<GetApiMembershipsData>) => createQueryKey('getApiMemberships', options);

/**
 * Retrieves available individual memberships for the Skin
 */
export const getApiMembershipsOptions = (options?: Options<GetApiMembershipsData>) => queryOptions<GetApiMembershipsResponse, AxiosError<GetApiMembershipsError>, GetApiMembershipsResponse, ReturnType<typeof getApiMembershipsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMemberships({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMembershipsQueryKey(options)
});
export const getApiMembershipsByMembershipIdQueryKey = (options: Options<GetApiMembershipsByMembershipIdData>) => createQueryKey('getApiMembershipsByMembershipId', options);

/**
 * Retrieves individual membership detail by ID
 */
export const getApiMembershipsByMembershipIdOptions = (options: Options<GetApiMembershipsByMembershipIdData>) => queryOptions<GetApiMembershipsByMembershipIdResponse, AxiosError<GetApiMembershipsByMembershipIdError>, GetApiMembershipsByMembershipIdResponse, ReturnType<typeof getApiMembershipsByMembershipIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMembershipsByMembershipId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMembershipsByMembershipIdQueryKey(options)
});
export const getApiMembershipsGroupsQueryKey = (options?: Options<GetApiMembershipsGroupsData>) => createQueryKey('getApiMembershipsGroups', options);

/**
 * Retrieves available Membership Groups for the Skin
 */
export const getApiMembershipsGroupsOptions = (options?: Options<GetApiMembershipsGroupsData>) => queryOptions<GetApiMembershipsGroupsResponse, AxiosError<GetApiMembershipsGroupsError>, GetApiMembershipsGroupsResponse, ReturnType<typeof getApiMembershipsGroupsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMembershipsGroups({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMembershipsGroupsQueryKey(options)
});
export const getApiMembershipsGroupsByUrlQueryKey = (options: Options<GetApiMembershipsGroupsByUrlData>) => createQueryKey('getApiMembershipsGroupsByUrl', options);

/**
 * Retrieves Membership Group detail by URL slug
 */
export const getApiMembershipsGroupsByUrlOptions = (options: Options<GetApiMembershipsGroupsByUrlData>) => queryOptions<GetApiMembershipsGroupsByUrlResponse, AxiosError<GetApiMembershipsGroupsByUrlError>, GetApiMembershipsGroupsByUrlResponse, ReturnType<typeof getApiMembershipsGroupsByUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMembershipsGroupsByUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMembershipsGroupsByUrlQueryKey(options)
});
export const getApiMobilepassTicketByEncryptedTicketIdQueryKey = (options: Options<GetApiMobilepassTicketByEncryptedTicketIdData>) => createQueryKey('getApiMobilepassTicketByEncryptedTicketId', options);

/**
 * Retrieves the mobile pass for a ticket
 */
export const getApiMobilepassTicketByEncryptedTicketIdOptions = (options: Options<GetApiMobilepassTicketByEncryptedTicketIdData>) => queryOptions<GetApiMobilepassTicketByEncryptedTicketIdResponse, AxiosError<GetApiMobilepassTicketByEncryptedTicketIdError>, GetApiMobilepassTicketByEncryptedTicketIdResponse, ReturnType<typeof getApiMobilepassTicketByEncryptedTicketIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMobilepassTicketByEncryptedTicketId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMobilepassTicketByEncryptedTicketIdQueryKey(options)
});
export const getApiMobilepassMembershipByEncryptedMembershipInstanceIdQueryKey = (options: Options<GetApiMobilepassMembershipByEncryptedMembershipInstanceIdData>) => createQueryKey('getApiMobilepassMembershipByEncryptedMembershipInstanceId', options);

/**
 * Retrieves the mobile pass for a membership
 */
export const getApiMobilepassMembershipByEncryptedMembershipInstanceIdOptions = (options: Options<GetApiMobilepassMembershipByEncryptedMembershipInstanceIdData>) => queryOptions<GetApiMobilepassMembershipByEncryptedMembershipInstanceIdResponse, AxiosError<GetApiMobilepassMembershipByEncryptedMembershipInstanceIdError>, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdResponse, ReturnType<typeof getApiMobilepassMembershipByEncryptedMembershipInstanceIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMobilepassMembershipByEncryptedMembershipInstanceId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMobilepassMembershipByEncryptedMembershipInstanceIdQueryKey(options)
});
export const getApiMobilepassGiftcardByEncryptedGiftcardIdQueryKey = (options: Options<GetApiMobilepassGiftcardByEncryptedGiftcardIdData>) => createQueryKey('getApiMobilepassGiftcardByEncryptedGiftcardId', options);

/**
 * Retrieves the mobile pass for a giftcard
 */
export const getApiMobilepassGiftcardByEncryptedGiftcardIdOptions = (options: Options<GetApiMobilepassGiftcardByEncryptedGiftcardIdData>) => queryOptions<GetApiMobilepassGiftcardByEncryptedGiftcardIdResponse, AxiosError<GetApiMobilepassGiftcardByEncryptedGiftcardIdError>, GetApiMobilepassGiftcardByEncryptedGiftcardIdResponse, ReturnType<typeof getApiMobilepassGiftcardByEncryptedGiftcardIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMobilepassGiftcardByEncryptedGiftcardId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMobilepassGiftcardByEncryptedGiftcardIdQueryKey(options)
});
export const getApiMobilepassOrderByEncryptedOrderIdQueryKey = (options: Options<GetApiMobilepassOrderByEncryptedOrderIdData>) => createQueryKey('getApiMobilepassOrderByEncryptedOrderId', options);

/**
 * Retrieves every wallet-eligible item on a sold order as one archive
 */
export const getApiMobilepassOrderByEncryptedOrderIdOptions = (options: Options<GetApiMobilepassOrderByEncryptedOrderIdData>) => queryOptions<GetApiMobilepassOrderByEncryptedOrderIdResponse, AxiosError<GetApiMobilepassOrderByEncryptedOrderIdError>, GetApiMobilepassOrderByEncryptedOrderIdResponse, ReturnType<typeof getApiMobilepassOrderByEncryptedOrderIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMobilepassOrderByEncryptedOrderId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMobilepassOrderByEncryptedOrderIdQueryKey(options)
});

/**
 * Creates the Apple Wallet links for a contactless order's tickets and subscriptions
 *
 * Call when the receipt's `walletBundle.isContactless` is true, on iOS only. Render each link as a plain
 * anchor the customer taps: Wallet only opens a universal link on a real navigation. Usually one link; an order
 * from several organisations, or with more passes than Wallet adds at once, gets several. The per-item and
 * bundle passes stay available for Android and older devices.
 */
export const postApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksMutation = (options?: Partial<Options<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksData>>): UseMutationOptions<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksResponse, AxiosError<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksError>, Options<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksData>> => {
  const mutationOptions: UseMutationOptions<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksResponse, AxiosError<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksError>, Options<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiMobilepassOrderByEncryptedOrderIdAppleWalletLinks({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiMobilepassSubscriptionByEncryptedTicketIdQueryKey = (options: Options<GetApiMobilepassSubscriptionByEncryptedTicketIdData>) => createQueryKey('getApiMobilepassSubscriptionByEncryptedTicketId', options);

/**
 * Retrieves the mobile pass for a subscription
 */
export const getApiMobilepassSubscriptionByEncryptedTicketIdOptions = (options: Options<GetApiMobilepassSubscriptionByEncryptedTicketIdData>) => queryOptions<GetApiMobilepassSubscriptionByEncryptedTicketIdResponse, AxiosError<GetApiMobilepassSubscriptionByEncryptedTicketIdError>, GetApiMobilepassSubscriptionByEncryptedTicketIdResponse, ReturnType<typeof getApiMobilepassSubscriptionByEncryptedTicketIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiMobilepassSubscriptionByEncryptedTicketId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiMobilepassSubscriptionByEncryptedTicketIdQueryKey(options)
});

/**
 * Cancels the customer's own reservation, releasing its seats back to the venue
 */
export const deleteApiOrdersByEncryptedOrderIdMutation = (options?: Partial<Options<DeleteApiOrdersByEncryptedOrderIdData>>): UseMutationOptions<unknown, AxiosError<DeleteApiOrdersByEncryptedOrderIdError>, Options<DeleteApiOrdersByEncryptedOrderIdData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteApiOrdersByEncryptedOrderIdError>, Options<DeleteApiOrdersByEncryptedOrderIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiOrdersByEncryptedOrderId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiOrdersByEncryptedOrderIdQueryKey = (options: Options<GetApiOrdersByEncryptedOrderIdData>) => createQueryKey('getApiOrdersByEncryptedOrderId', options);

/**
 * Attempts to retrieve a order specified by orderId
 */
export const getApiOrdersByEncryptedOrderIdOptions = (options: Options<GetApiOrdersByEncryptedOrderIdData>) => queryOptions<unknown, AxiosError<GetApiOrdersByEncryptedOrderIdError>, unknown, ReturnType<typeof getApiOrdersByEncryptedOrderIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiOrdersByEncryptedOrderId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiOrdersByEncryptedOrderIdQueryKey(options)
});

/**
 * Attempts to "claim" a special offer using either a password (in request body) or web user access (if authenticated)
 */
export const postApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdData>>): UseMutationOptions<unknown, AxiosError<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdError>, Options<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdError>, Options<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Attempts to add the specified unnumbered tickets to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdTicketsUnnumberedMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedResponse, AxiosError<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedError>, Options<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedResponse, AxiosError<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedError>, Options<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdTicketsUnnumbered({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Updates the CustomerNote property on an order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdCustomerNoteMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdCustomerNoteData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdCustomerNoteResponse, AxiosError<PostApiOrdersByEncryptedOrderIdCustomerNoteError>, Options<PostApiOrdersByEncryptedOrderIdCustomerNoteData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdCustomerNoteResponse, AxiosError<PostApiOrdersByEncryptedOrderIdCustomerNoteError>, Options<PostApiOrdersByEncryptedOrderIdCustomerNoteData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdCustomerNote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Extends the expiry time of the specified order by 5 minutes.
 */
export const postApiOrdersByEncryptedOrderIdExpiryExtendMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdExpiryExtendData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdExpiryExtendResponse, AxiosError<PostApiOrdersByEncryptedOrderIdExpiryExtendError>, Options<PostApiOrdersByEncryptedOrderIdExpiryExtendData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdExpiryExtendResponse, AxiosError<PostApiOrdersByEncryptedOrderIdExpiryExtendError>, Options<PostApiOrdersByEncryptedOrderIdExpiryExtendData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdExpiryExtend({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiOrdersByEncryptedOrderIdDeliveryTypesQueryKey = (options: Options<GetApiOrdersByEncryptedOrderIdDeliveryTypesData>) => createQueryKey('getApiOrdersByEncryptedOrderIdDeliveryTypes', options);

/**
 * Fetches the available delivery types for the specified order.
 */
export const getApiOrdersByEncryptedOrderIdDeliveryTypesOptions = (options: Options<GetApiOrdersByEncryptedOrderIdDeliveryTypesData>) => queryOptions<GetApiOrdersByEncryptedOrderIdDeliveryTypesResponse, AxiosError<GetApiOrdersByEncryptedOrderIdDeliveryTypesError>, GetApiOrdersByEncryptedOrderIdDeliveryTypesResponse, ReturnType<typeof getApiOrdersByEncryptedOrderIdDeliveryTypesQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiOrdersByEncryptedOrderIdDeliveryTypes({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiOrdersByEncryptedOrderIdDeliveryTypesQueryKey(options)
});

/**
 * Attempts to remove everything connected to an event in the order
 */
export const deleteApiOrdersByEncryptedOrderIdEventByEventIdMutation = (options?: Partial<Options<DeleteApiOrdersByEncryptedOrderIdEventByEventIdData>>): UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdEventByEventIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdEventByEventIdError>, Options<DeleteApiOrdersByEncryptedOrderIdEventByEventIdData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdEventByEventIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdEventByEventIdError>, Options<DeleteApiOrdersByEncryptedOrderIdEventByEventIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiOrdersByEncryptedOrderIdEventByEventId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Attempts to delete tickets from an order
 */
export const deleteApiOrdersByEncryptedOrderIdTicketsMutation = (options?: Partial<Options<DeleteApiOrdersByEncryptedOrderIdTicketsData>>): UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdTicketsResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdTicketsError>, Options<DeleteApiOrdersByEncryptedOrderIdTicketsData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdTicketsResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdTicketsError>, Options<DeleteApiOrdersByEncryptedOrderIdTicketsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiOrdersByEncryptedOrderIdTickets({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Attempts to add tickets to an order
 */
export const postApiOrdersByEncryptedOrderIdTicketsMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdTicketsData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdTicketsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdTicketsError>, Options<PostApiOrdersByEncryptedOrderIdTicketsData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdTicketsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdTicketsError>, Options<PostApiOrdersByEncryptedOrderIdTicketsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdTickets({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Attempts to create an order with tickets
 */
export const postApiOrdersMutation = (options?: Partial<Options<PostApiOrdersData>>): UseMutationOptions<PostApiOrdersResponse, AxiosError<PostApiOrdersError>, Options<PostApiOrdersData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersResponse, AxiosError<PostApiOrdersError>, Options<PostApiOrdersData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrders({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Attempts to claim an order
 */
export const postApiOrdersByEncryptedOrderIdClaimMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdClaimData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdClaimResponse, AxiosError<PostApiOrdersByEncryptedOrderIdClaimError>, Options<PostApiOrdersByEncryptedOrderIdClaimData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdClaimResponse, AxiosError<PostApiOrdersByEncryptedOrderIdClaimError>, Options<PostApiOrdersByEncryptedOrderIdClaimData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdClaim({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Evaluates basket rules for the order, applying any discount code already on it.
 */
export const postApiOrdersByEncryptedOrderIdEvaluateRulesMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdEvaluateRulesData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdEvaluateRulesResponse, AxiosError<PostApiOrdersByEncryptedOrderIdEvaluateRulesError>, Options<PostApiOrdersByEncryptedOrderIdEvaluateRulesData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdEvaluateRulesResponse, AxiosError<PostApiOrdersByEncryptedOrderIdEvaluateRulesError>, Options<PostApiOrdersByEncryptedOrderIdEvaluateRulesData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdEvaluateRules({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Applies a discount code to the order, matching it against event vouchers first and then
 * promo-code basket rules.
 */
export const postApiOrdersByEncryptedOrderIdDiscountCodeMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdDiscountCodeData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdDiscountCodeResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDiscountCodeError>, Options<PostApiOrdersByEncryptedOrderIdDiscountCodeData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdDiscountCodeResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDiscountCodeError>, Options<PostApiOrdersByEncryptedOrderIdDiscountCodeData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdDiscountCode({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesQueryKey = (options: Options<GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData>) => createQueryKey('getApiOrdersByEncryptedOrderIdEventsByEventIdAttendees', options);

/**
 * Returns attendee form data for a single event in the order, with each row pre-populated
 * from the reservation's customer or left empty for anonymous reservations.
 */
export const getApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesOptions = (options: Options<GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData>) => queryOptions<GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponse, AxiosError<GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesError>, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponse, ReturnType<typeof getApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiOrdersByEncryptedOrderIdEventsByEventIdAttendees({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesQueryKey(options)
});

/**
 * Updates attendee information on tickets for a single event in the order.
 */
export const patchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesMutation = (options?: Partial<Options<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData>>): UseMutationOptions<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponse, AxiosError<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesError>, Options<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData>> => {
  const mutationOptions: UseMutationOptions<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponse, AxiosError<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesError>, Options<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await patchApiOrdersByEncryptedOrderIdEventsByEventIdAttendees({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Deletes a gift card from the order
 */
export const deleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdMutation = (options?: Partial<Options<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdData>>): UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdError>, Options<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdError>, Options<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Adds gift cards to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdGiftcardsMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdGiftcardsData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdGiftcardsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdGiftcardsError>, Options<PostApiOrdersByEncryptedOrderIdGiftcardsData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdGiftcardsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdGiftcardsError>, Options<PostApiOrdersByEncryptedOrderIdGiftcardsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdGiftcards({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Deletes a membership from the order
 */
export const deleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdMutation = (options?: Partial<Options<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdData>>): UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdError>, Options<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdError>, Options<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Adds a membership to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdMembershipsMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdMembershipsData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdMembershipsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdMembershipsError>, Options<PostApiOrdersByEncryptedOrderIdMembershipsData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdMembershipsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdMembershipsError>, Options<PostApiOrdersByEncryptedOrderIdMembershipsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdMemberships({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Deletes a donation from the order
 */
export const deleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdMutation = (options?: Partial<Options<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdData>>): UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdError>, Options<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdError>, Options<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Adds a donation to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdDonationsMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdDonationsData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdDonationsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDonationsError>, Options<PostApiOrdersByEncryptedOrderIdDonationsData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdDonationsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdDonationsError>, Options<PostApiOrdersByEncryptedOrderIdDonationsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdDonations({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Removes add-on product units from the order, all or nothing. Each id is the EncryptedOrderProductId of one
 * unit; refuses with 409 for an id that is not an add-on on this order, or when the removal would leave a
 * product without the product it can only be bought together with.
 */
export const deleteApiOrdersByEncryptedOrderIdProductsMutation = (options?: Partial<Options<DeleteApiOrdersByEncryptedOrderIdProductsData>>): UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdProductsResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdProductsError>, Options<DeleteApiOrdersByEncryptedOrderIdProductsData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiOrdersByEncryptedOrderIdProductsResponse, AxiosError<DeleteApiOrdersByEncryptedOrderIdProductsError>, Options<DeleteApiOrdersByEncryptedOrderIdProductsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiOrdersByEncryptedOrderIdProducts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Adds product variants for an event the order holds tickets for. All or nothing: refuses with 409
 * naming the item when the event quota or stock cannot cover the whole request.
 */
export const postApiOrdersByEncryptedOrderIdProductsMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdProductsData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdProductsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdProductsError>, Options<PostApiOrdersByEncryptedOrderIdProductsData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdProductsResponse, AxiosError<PostApiOrdersByEncryptedOrderIdProductsError>, Options<PostApiOrdersByEncryptedOrderIdProductsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdProducts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Moves the selected items onto a new reservation, leaving this order holding the rest. The
 * order keeps its id and is the one that goes on to be paid.
 */
export const postApiOrdersByEncryptedOrderIdSplitMutation = (options?: Partial<Options<PostApiOrdersByEncryptedOrderIdSplitData>>): UseMutationOptions<PostApiOrdersByEncryptedOrderIdSplitResponse, AxiosError<PostApiOrdersByEncryptedOrderIdSplitError>, Options<PostApiOrdersByEncryptedOrderIdSplitData>> => {
  const mutationOptions: UseMutationOptions<PostApiOrdersByEncryptedOrderIdSplitResponse, AxiosError<PostApiOrdersByEncryptedOrderIdSplitError>, Options<PostApiOrdersByEncryptedOrderIdSplitData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiOrdersByEncryptedOrderIdSplit({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiEventsByEventIdProductsQueryKey = (options: Options<GetApiEventsByEventIdProductsData>) => createQueryKey('getApiEventsByEventIdProducts', options);

/**
 * Retrieves the products and product variants sellable online for an event, with the event's texts for the products step
 */
export const getApiEventsByEventIdProductsOptions = (options: Options<GetApiEventsByEventIdProductsData>) => queryOptions<GetApiEventsByEventIdProductsResponse, AxiosError<GetApiEventsByEventIdProductsError>, GetApiEventsByEventIdProductsResponse, ReturnType<typeof getApiEventsByEventIdProductsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiEventsByEventIdProducts({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiEventsByEventIdProductsQueryKey(options)
});

/**
 * Anonymises the logged-in web user's customer record and retires the login. Only available when
 * the workgroup allows user deletion.
 */
export const deleteApiProfileMeMutation = (options?: Partial<Options<DeleteApiProfileMeData>>): UseMutationOptions<unknown, AxiosError<DeleteApiProfileMeError>, Options<DeleteApiProfileMeData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteApiProfileMeError>, Options<DeleteApiProfileMeData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiProfileMe({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiProfileMeQueryKey = (options?: Options<GetApiProfileMeData>) => createQueryKey('getApiProfileMe', options);

/**
 * Attempts to retrieve the user profile for the logged-in web user
 */
export const getApiProfileMeOptions = (options?: Options<GetApiProfileMeData>) => queryOptions<GetApiProfileMeResponse, AxiosError<GetApiProfileMeError>, GetApiProfileMeResponse, ReturnType<typeof getApiProfileMeQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiProfileMe({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiProfileMeQueryKey(options)
});

/**
 * Updates WebCustomer attributes for the logged-in web user
 */
export const postApiProfileMeMutation = (options?: Partial<Options<PostApiProfileMeData>>): UseMutationOptions<PostApiProfileMeResponse, AxiosError<PostApiProfileMeError>, Options<PostApiProfileMeData>> => {
  const mutationOptions: UseMutationOptions<PostApiProfileMeResponse, AxiosError<PostApiProfileMeError>, Options<PostApiProfileMeData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiProfileMe({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Updates the date of birth for the logged-in user's customer record
 */
export const patchApiProfileMeDateOfBirthMutation = (options?: Partial<Options<PatchApiProfileMeDateOfBirthData>>): UseMutationOptions<unknown, AxiosError<PatchApiProfileMeDateOfBirthError>, Options<PatchApiProfileMeDateOfBirthData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchApiProfileMeDateOfBirthError>, Options<PatchApiProfileMeDateOfBirthData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await patchApiProfileMeDateOfBirth({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiProfileMeExportQueryKey = (options?: Options<GetApiProfileMeExportData>) => createQueryKey('getApiProfileMeExport', options);

/**
 * Returns a zip of CSV files covering every record this workgroup holds about the logged-in
 * web user. Only available when the workgroup allows user data export.
 */
export const getApiProfileMeExportOptions = (options?: Options<GetApiProfileMeExportData>) => queryOptions<GetApiProfileMeExportResponse, AxiosError<GetApiProfileMeExportError>, GetApiProfileMeExportResponse, ReturnType<typeof getApiProfileMeExportQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiProfileMeExport({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiProfileMeExportQueryKey(options)
});
export const getApiProfileMePermissionsQueryKey = (options?: Options<GetApiProfileMePermissionsData>) => createQueryKey('getApiProfileMePermissions', options);

/**
 * Returns the marketing permissions visible to the logged-in web user, each with the toggle
 * state the buyer should see. A permission answered per performance appears once per event.
 */
export const getApiProfileMePermissionsOptions = (options?: Options<GetApiProfileMePermissionsData>) => queryOptions<GetApiProfileMePermissionsResponse, AxiosError<GetApiProfileMePermissionsError>, GetApiProfileMePermissionsResponse, ReturnType<typeof getApiProfileMePermissionsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiProfileMePermissions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiProfileMePermissionsQueryKey(options)
});

/**
 * Records the logged-in web user's answer to one marketing permission.
 */
export const putApiProfileMePermissionsByPermissionIdMutation = (options?: Partial<Options<PutApiProfileMePermissionsByPermissionIdData>>): UseMutationOptions<unknown, AxiosError<PutApiProfileMePermissionsByPermissionIdError>, Options<PutApiProfileMePermissionsByPermissionIdData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PutApiProfileMePermissionsByPermissionIdError>, Options<PutApiProfileMePermissionsByPermissionIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await putApiProfileMePermissionsByPermissionId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiProfileOrdersQueryKey = (options?: Options<GetApiProfileOrdersData>) => createQueryKey('getApiProfileOrders', options);

/**
 * Attempts to retrieve all orders belonging to the logged-in web user
 */
export const getApiProfileOrdersOptions = (options?: Options<GetApiProfileOrdersData>) => queryOptions<GetApiProfileOrdersResponse, AxiosError<GetApiProfileOrdersError>, GetApiProfileOrdersResponse, ReturnType<typeof getApiProfileOrdersQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiProfileOrders({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiProfileOrdersQueryKey(options)
});
export const getApiProfileGiftcardsQueryKey = (options?: Options<GetApiProfileGiftcardsData>) => createQueryKey('getApiProfileGiftcards', options);

/**
 * Retrieves gift cards belonging to the logged-in web user
 */
export const getApiProfileGiftcardsOptions = (options?: Options<GetApiProfileGiftcardsData>) => queryOptions<GetApiProfileGiftcardsResponse, AxiosError<GetApiProfileGiftcardsError>, GetApiProfileGiftcardsResponse, ReturnType<typeof getApiProfileGiftcardsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiProfileGiftcards({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiProfileGiftcardsQueryKey(options)
});
export const getApiProfileMembershipsQueryKey = (options?: Options<GetApiProfileMembershipsData>) => createQueryKey('getApiProfileMemberships', options);

/**
 * Retrieves memberships belonging to the logged-in web user
 */
export const getApiProfileMembershipsOptions = (options?: Options<GetApiProfileMembershipsData>) => queryOptions<GetApiProfileMembershipsResponse, AxiosError<GetApiProfileMembershipsError>, GetApiProfileMembershipsResponse, ReturnType<typeof getApiProfileMembershipsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiProfileMemberships({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiProfileMembershipsQueryKey(options)
});

/**
 * Cancels auto-renewal for a membership instance belonging to the logged-in web user
 */
export const postApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalMutation = (options?: Partial<Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalData>>): UseMutationOptions<unknown, AxiosError<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalError>, Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalError>, Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewal({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Enables auto-renewal for a membership instance belonging to the logged-in web user
 */
export const postApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalMutation = (options?: Partial<Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalData>>): UseMutationOptions<unknown, AxiosError<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalError>, Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalError>, Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewal({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiProfileEventsByEventIdAttendeesQueryKey = (options: Options<GetApiProfileEventsByEventIdAttendeesData>) => createQueryKey('getApiProfileEventsByEventIdAttendees', options);

/**
 * Returns the merged attendee form for every ticket the logged-in user owns for a single
 * event, across all their sold orders. Used by the My Pages "Edit attendee info" entry
 * so the user never has to disambiguate between multiple orders covering the same event.
 */
export const getApiProfileEventsByEventIdAttendeesOptions = (options: Options<GetApiProfileEventsByEventIdAttendeesData>) => queryOptions<GetApiProfileEventsByEventIdAttendeesResponse, AxiosError<GetApiProfileEventsByEventIdAttendeesError>, GetApiProfileEventsByEventIdAttendeesResponse, ReturnType<typeof getApiProfileEventsByEventIdAttendeesQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiProfileEventsByEventIdAttendees({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiProfileEventsByEventIdAttendeesQueryKey(options)
});

/**
 * Updates attendee information for the logged-in user's tickets across every sold order
 * containing the event in a single transactional write. Validates the event's uniqueness
 * constraints against the full merged set before persisting.
 */
export const patchApiProfileEventsByEventIdAttendeesMutation = (options?: Partial<Options<PatchApiProfileEventsByEventIdAttendeesData>>): UseMutationOptions<PatchApiProfileEventsByEventIdAttendeesResponse, AxiosError<PatchApiProfileEventsByEventIdAttendeesError>, Options<PatchApiProfileEventsByEventIdAttendeesData>> => {
  const mutationOptions: UseMutationOptions<PatchApiProfileEventsByEventIdAttendeesResponse, AxiosError<PatchApiProfileEventsByEventIdAttendeesError>, Options<PatchApiProfileEventsByEventIdAttendeesData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await patchApiProfileEventsByEventIdAttendees({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Attempts to purchase the order and create a sale
 */
export const postApiPurchaseByEncryptedOrderIdMutation = (options?: Partial<Options<PostApiPurchaseByEncryptedOrderIdData>>): UseMutationOptions<PostApiPurchaseByEncryptedOrderIdResponse, AxiosError<PostApiPurchaseByEncryptedOrderIdError>, Options<PostApiPurchaseByEncryptedOrderIdData>> => {
  const mutationOptions: UseMutationOptions<PostApiPurchaseByEncryptedOrderIdResponse, AxiosError<PostApiPurchaseByEncryptedOrderIdError>, Options<PostApiPurchaseByEncryptedOrderIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiPurchaseByEncryptedOrderId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiReceiptByEncryptedOrderIdQueryKey = (options: Options<GetApiReceiptByEncryptedOrderIdData>) => createQueryKey('getApiReceiptByEncryptedOrderId', options);

/**
 * Attempts to get receipt for the order
 */
export const getApiReceiptByEncryptedOrderIdOptions = (options: Options<GetApiReceiptByEncryptedOrderIdData>) => queryOptions<GetApiReceiptByEncryptedOrderIdResponse, AxiosError<GetApiReceiptByEncryptedOrderIdError>, GetApiReceiptByEncryptedOrderIdResponse, ReturnType<typeof getApiReceiptByEncryptedOrderIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiReceiptByEncryptedOrderId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiReceiptByEncryptedOrderIdQueryKey(options)
});
export const getApiReceiptByEncryptedOrderIdRefundByEventIdQueryKey = (options: Options<GetApiReceiptByEncryptedOrderIdRefundByEventIdData>) => createQueryKey('getApiReceiptByEncryptedOrderIdRefundByEventId', options);

/**
 * Refund options and amounts for one cancelled/moved event on the order, for the refund screen.
 */
export const getApiReceiptByEncryptedOrderIdRefundByEventIdOptions = (options: Options<GetApiReceiptByEncryptedOrderIdRefundByEventIdData>) => queryOptions<GetApiReceiptByEncryptedOrderIdRefundByEventIdResponse, AxiosError<GetApiReceiptByEncryptedOrderIdRefundByEventIdError>, GetApiReceiptByEncryptedOrderIdRefundByEventIdResponse, ReturnType<typeof getApiReceiptByEncryptedOrderIdRefundByEventIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiReceiptByEncryptedOrderIdRefundByEventId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiReceiptByEncryptedOrderIdRefundByEventIdQueryKey(options)
});

/**
 * Refunds all of the order's tickets for one cancelled/moved event, as a gift card, a donation, a
 * bank transfer, or back to the original payment method. That last one only registers for a card
 * order, so the tickets survive, and goes straight through Briqpay for a Briqpay order.
 */
export const postApiReceiptByEncryptedOrderIdRefundByEventIdMutation = (options?: Partial<Options<PostApiReceiptByEncryptedOrderIdRefundByEventIdData>>): UseMutationOptions<unknown, AxiosError<PostApiReceiptByEncryptedOrderIdRefundByEventIdError>, Options<PostApiReceiptByEncryptedOrderIdRefundByEventIdData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiReceiptByEncryptedOrderIdRefundByEventIdError>, Options<PostApiReceiptByEncryptedOrderIdRefundByEventIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiReceiptByEncryptedOrderIdRefundByEventId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiReceiptByEncryptedOrderIdStatusQueryKey = (options: Options<GetApiReceiptByEncryptedOrderIdStatusData>) => createQueryKey('getApiReceiptByEncryptedOrderIdStatus', options);

/**
 * Cheap pollable status while the FE waits for CloseSaleProcessor to consume the Briqpay webhook
 * and create the sale. Ready=true means it's safe to fetch the full receipt.
 */
export const getApiReceiptByEncryptedOrderIdStatusOptions = (options: Options<GetApiReceiptByEncryptedOrderIdStatusData>) => queryOptions<GetApiReceiptByEncryptedOrderIdStatusResponse, AxiosError<GetApiReceiptByEncryptedOrderIdStatusError>, GetApiReceiptByEncryptedOrderIdStatusResponse, ReturnType<typeof getApiReceiptByEncryptedOrderIdStatusQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiReceiptByEncryptedOrderIdStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiReceiptByEncryptedOrderIdStatusQueryKey(options)
});
export const getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfQueryKey = (options: Options<GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfData>) => createQueryKey('getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdf', options);

/**
 * Streams one of the order's documents (ticket, receipt, ...), rendered by the PDF service,
 * back to the caller. The document type is bound from the route by its enum name (e.g. "Ticket").
 * Passing an encrypted item id narrows the document to that item, which My Pages uses to download
 * a single gift card or membership rather than every one on the order. The Invoice type instead
 * takes a transaction id from the receipt's invoice list, naming the invoice to render.
 */
export const getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfOptions = (options: Options<GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfData>) => queryOptions<GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfResponse, AxiosError<GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfError>, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfResponse, ReturnType<typeof getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdf({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfQueryKey(options)
});
export const getApiSpecialOffersByEncryptedSpecialOfferIdQueryKey = (options: Options<GetApiSpecialOffersByEncryptedSpecialOfferIdData>) => createQueryKey('getApiSpecialOffersByEncryptedSpecialOfferId', options);

/**
 * Retrieves special offer by encrypted specialOfferId
 */
export const getApiSpecialOffersByEncryptedSpecialOfferIdOptions = (options: Options<GetApiSpecialOffersByEncryptedSpecialOfferIdData>) => queryOptions<GetApiSpecialOffersByEncryptedSpecialOfferIdResponse, AxiosError<GetApiSpecialOffersByEncryptedSpecialOfferIdError>, GetApiSpecialOffersByEncryptedSpecialOfferIdResponse, ReturnType<typeof getApiSpecialOffersByEncryptedSpecialOfferIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiSpecialOffersByEncryptedSpecialOfferId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiSpecialOffersByEncryptedSpecialOfferIdQueryKey(options)
});
export const getApiSpecialOffersQueryKey = (options?: Options<GetApiSpecialOffersData>) => createQueryKey('getApiSpecialOffers', options);

/**
 * Returns all active special offers available to the authenticated web user.
 */
export const getApiSpecialOffersOptions = (options?: Options<GetApiSpecialOffersData>) => queryOptions<GetApiSpecialOffersResponse, AxiosError<GetApiSpecialOffersError>, GetApiSpecialOffersResponse, ReturnType<typeof getApiSpecialOffersQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiSpecialOffers({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiSpecialOffersQueryKey(options)
});
export const getApiSubscriptionTypesQueryKey = (options?: Options<GetApiSubscriptionTypesData>) => createQueryKey('getApiSubscriptionTypes', options);

/**
 * Retrieves the subscription types with a landing page on this storefront
 */
export const getApiSubscriptionTypesOptions = (options?: Options<GetApiSubscriptionTypesData>) => queryOptions<GetApiSubscriptionTypesResponse, AxiosError<GetApiSubscriptionTypesError>, GetApiSubscriptionTypesResponse, ReturnType<typeof getApiSubscriptionTypesQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiSubscriptionTypes({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiSubscriptionTypesQueryKey(options)
});
export const getApiSubscriptionTypesBySubscriptionTypeIdQueryKey = (options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdData>) => createQueryKey('getApiSubscriptionTypesBySubscriptionTypeId', options);

/**
 * Retrieves subscription type by Id
 */
export const getApiSubscriptionTypesBySubscriptionTypeIdOptions = (options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdData>) => queryOptions<GetApiSubscriptionTypesBySubscriptionTypeIdResponse, AxiosError<GetApiSubscriptionTypesBySubscriptionTypeIdError>, GetApiSubscriptionTypesBySubscriptionTypeIdResponse, ReturnType<typeof getApiSubscriptionTypesBySubscriptionTypeIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiSubscriptionTypesBySubscriptionTypeId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiSubscriptionTypesBySubscriptionTypeIdQueryKey(options)
});
export const getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsQueryKey = (options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsData>) => createQueryKey('getApiSubscriptionTypesBySubscriptionTypeIdEventGroups', options);

/**
 * Retrieves event groups for a subscription with summary info.
 */
export const getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsOptions = (options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsData>) => queryOptions<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsResponse, AxiosError<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsError>, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsResponse, ReturnType<typeof getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiSubscriptionTypesBySubscriptionTypeIdEventGroups({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsQueryKey(options)
});
export const getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsQueryKey = (options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsData>) => createQueryKey('getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEvents', options);

/**
 * Retrieves paged events within a specific event group that are eligible for the given subscription type.
 */
export const getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsOptions = (options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsData>) => queryOptions<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsResponse, AxiosError<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsError>, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsResponse, ReturnType<typeof getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEvents({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsQueryKey(options)
});

/**
 * Attempts to delete tickets
 */
export const deleteApiTicketsMutation = (options?: Partial<Options<DeleteApiTicketsData>>): UseMutationOptions<unknown, AxiosError<DeleteApiTicketsError>, Options<DeleteApiTicketsData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteApiTicketsError>, Options<DeleteApiTicketsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteApiTickets({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Validates a completed seat-picker step's reserved tickets (single-seat rule and per-event
 * subscription limits) so errors surface per step instead of only at order creation.
 */
export const postApiTicketsValidateMutation = (options?: Partial<Options<PostApiTicketsValidateData>>): UseMutationOptions<unknown, AxiosError<PostApiTicketsValidateError>, Options<PostApiTicketsValidateData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiTicketsValidateError>, Options<PostApiTicketsValidateData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiTicketsValidate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Attempts to update ticket type
 *
 * encryptedOrderId is the encrypted id of the order the ticket sits in, and is
 * required for any ticket that is in one, since it is what proves the caller may change this ticket.
 */
export const patchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdMutation = (options?: Partial<Options<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdData>>): UseMutationOptions<unknown, AxiosError<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdError>, Options<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdError>, Options<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await patchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getApiVersionQueryKey = (options?: Options<GetApiVersionData>) => createQueryKey('getApiVersion', options);

/**
 * Returns the deployed build version.
 */
export const getApiVersionOptions = (options?: Options<GetApiVersionData>) => queryOptions<GetApiVersionResponse, AxiosError<DefaultError>, GetApiVersionResponse, ReturnType<typeof getApiVersionQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getApiVersion({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getApiVersionQueryKey(options)
});

/**
 * Registers a waiting-list signup for a sold-out event and sends the confirmation email.
 */
export const postApiWaitingListByEventIdSignupMutation = (options?: Partial<Options<PostApiWaitingListByEventIdSignupData>>): UseMutationOptions<unknown, AxiosError<PostApiWaitingListByEventIdSignupError>, Options<PostApiWaitingListByEventIdSignupData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiWaitingListByEventIdSignupError>, Options<PostApiWaitingListByEventIdSignupData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiWaitingListByEventIdSignup({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirms a waiting-list signup from the emailed link (matches on signup id + email).
 */
export const postApiWaitingListConfirmMutation = (options?: Partial<Options<PostApiWaitingListConfirmData>>): UseMutationOptions<unknown, AxiosError<PostApiWaitingListConfirmError>, Options<PostApiWaitingListConfirmData>> => {
  const mutationOptions: UseMutationOptions<unknown, AxiosError<PostApiWaitingListConfirmError>, Options<PostApiWaitingListConfirmData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await postApiWaitingListConfirm({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};